<template>
  <div class="dem-pro-item-2">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <div class="separacao" v-else-if='statusGeral === ""'>
      <div v-if="dados.nfEmitida === false">
        <div>
          <!-- SETA O BOTÃO DE PROTEGIDO -->
          <App-Toggles :data-time="time" :class="campos.mascaramento.class" class="dem-edi-pro-tab-item-editar--mascaramento" v-if="[ '', 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(dados.demanda_p_doc_tp) !== -1"
            :cpntStatus='campos.mascaramento.status'
            :cpntId='campos.mascaramento.id'
            :cpntAlerta='campos.mascaramento.alerta'
            :cpntClassDivField='campos.mascaramento.classDivField'
            :cpntNome='campos.mascaramento.nome'
            :cpntValue='campos.mascaramento.value'
            :cpntMostrar='campos.mascaramento.mostrar'
            :cpntMensagem='campos.mascaramento.mensagem'
            :cpntMensagemTipo='campos.mascaramento.mensagemTipo'
            :cpntOn='campos.mascaramento.on'
            :cpntOff='campos.mascaramento.off'
            :cpntExplica='campos.mascaramento.explica'
            :cpntTitle='campos.mascaramento.title'
            :cpntWidth='campos.mascaramento.width'
            :cpntTabIndex='campos.mascaramento.tabIndex'
            :cpntDisabled='campos.mascaramento.disabled'
            :cpntOnChange='campos.mascaramento.onChange'
            :cpntOnBlur='campos.mascaramento.onBlur'
            ref='mascaramento'
          ></App-Toggles>

          <!-- SETA O BOTÃO DE SALVAR -->
          <App-Button :data-time="time" class="dem-edi-pro-tab-item-editar--salvar" :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick="emEdiProTabItemEditarSalvar">Salvar</App-Button>

          <!-- QUEBRA O FLOAT DO CMAPO -->
          <div style="clear: both; height: 1px;"></div>
        </div>
      </div>

      <div class="quadrado">
        <div>
          <App-Input :data-time="time" :class="campos.id_pro_codigo.class" class="dem-edi-pro-tab-item-editar--id_pro_codigo"
            :cpntStatus='campos.id_pro_codigo.status'
            :cpntId='campos.id_pro_codigo.id'
            :cpntAlerta='campos.id_pro_codigo.alerta'
            :cpntTabIndex='campos.id_pro_codigo.tabIndex'
            :cpntNome='campos.id_pro_codigo.nome'
            :cpntValue='campos.id_pro_codigo.value'
            :cpntMensagem='campos.id_pro_codigo.mensagem'
            :cpntMensagemTipo='campos.id_pro_codigo.mensagemTipo'
            :cpntDisabled='campos.id_pro_codigo.disabled()'
            :cpntMostrar='campos.id_pro_codigo.mostrar'
            :cpntExplica='campos.id_pro_codigo.explica'
            :cpntPlaceholder='campos.id_pro_codigo.placeholder'
            :cpntValueRef='campos.id_pro_codigo.valueRef'
            :cpntRouter='campos.id_pro_codigo.router'
            :cpntField='campos.id_pro_codigo.field'
            :cpntWhere='campos.id_pro_codigo.where'
            :cpntAddButForm='campos.id_pro_codigo.addButForm'
            :cpntKeyMostra='campos.id_pro_codigo.keyMostra'
            :cpntTipoOrder='campos.id_pro_codigo.tipoOrder'
            :cpntOrder='campos.id_pro_codigo.order'
            :cpntOptions='campos.id_pro_codigo.options'
            :cpntKeyValue='campos.id_pro_codigo.keyValue'
            :cpntSearchMinimo='campos.id_pro_codigo.searchMinimo'
            :cpntMask='campos.id_pro_codigo.mask'

            :cpntOnChange='campos.id_pro_codigo.onChange'
            :cpntOnBlur='campos.id_pro_codigo.onBlur'
            :cpntOnRealizaBusca='campos.id_pro_codigo.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.id_pro_codigo.onKeyPressEnter'
            ref="id_pro_codigo"
          ></App-Input>

          <App-Autocompletar :data-time="time" :class="campos.id_pro_nome.class" class="dem-edi-pro-tab-item-editar--id_pro_nome"
            :cpntStatus='campos.id_pro_nome.status'
            :cpntId='campos.id_pro_nome.id'
            :cpntAlerta='campos.id_pro_nome.alerta'
            :cpntTabIndex='campos.id_pro_nome.tabIndex'
            :cpntNome='campos.id_pro_nome.nome'
            :cpntValue='campos.id_pro_nome.value'
            :cpntMensagem='campos.id_pro_nome.mensagem'
            :cpntMensagemTipo='campos.id_pro_nome.mensagemTipo'
            :cpntDisabled='campos.id_pro_nome.disabled()'
            :cpntMostrar='campos.id_pro_nome.mostrar'
            :cpntExplica='campos.id_pro_nome.explica'
            :cpntPlaceholder='campos.id_pro_nome.placeholder'
            :cpntValueRef='campos.id_pro_nome.valueRef'
            :cpntRouter='campos.id_pro_nome.router'
            :cpntMethod='campos.id_pro_nome.method'
            :cpntField='campos.id_pro_nome.field'
            :cpntFieldVirtual='campos.id_pro_nome.fieldVirtual'
            :cpntWhere='campos.id_pro_nome.where'
            :cpntAddButForm='campos.id_pro_nome.addButForm'
            :cpntKeyMostra='campos.id_pro_nome.keyMostra'
            :cpntTipoOrder='campos.id_pro_nome.tipoOrder'
            :cpntOrder='campos.id_pro_nome.order'
            :cpntOptions='campos.id_pro_nome.options'
            :cpntKeyValue='campos.id_pro_nome.keyValue'
            :cpntSearchMinimo='campos.id_pro_nome.searchMinimo'
            :cpntMask='campos.id_pro_nome.mask'
            :cpntNewOption='campos.id_pro_nome.newOption'

            :cpntOnChange='campos.id_pro_nome.onChange'
            :cpntOnBlur='campos.id_pro_nome.onBlur'
            :cpntOnRealizaBusca='campos.id_pro_nome.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.id_pro_nome.onKeyPressEnter'
            ref="id_pro_nome"
          ></App-Autocompletar>

          <App-Input :data-time="time" :class="campos.qtde.class" class="dem-edi-pro-tab-item-editar--qtde"
            :cpntStatus='campos.qtde.status'
            :cpntId='campos.qtde.id'
            :cpntAlerta='campos.qtde.alerta'
            :cpntTabIndex='campos.qtde.tabIndex'
            :cpntNome='campos.qtde.nome'
            :cpntValue='campos.qtde.value'
            :cpntMensagem='campos.qtde.mensagem'
            :cpntMensagemTipo='campos.qtde.mensagemTipo'
            :cpntDisabled='campos.qtde.disabled()'
            :cpntMostrar='campos.qtde.mostrar'
            :cpntExplica='campos.qtde.explica'
            :cpntPlaceholder='campos.qtde.placeholder'
            :cpntValueRef='campos.qtde.valueRef'
            :cpntRouter='campos.qtde.router'
            :cpntField='campos.qtde.field'
            :cpntWhere='campos.qtde.where'
            :cpntAddButForm='campos.qtde.addButForm'
            :cpntKeyMostra='campos.qtde.keyMostra'
            :cpntTipoOrder='campos.qtde.tipoOrder'
            :cpntOrder='campos.qtde.order'
            :cpntOptions='campos.qtde.options'
            :cpntKeyValue='campos.qtde.keyValue'
            :cpntSearchMinimo='campos.qtde.searchMinimo'
            :cpntMask='campos.qtde.mask'

            :cpntOnChange='campos.qtde.onChange'
            :cpntOnBlur='campos.qtde.onBlur'
            :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
            ref="qtde"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.valor_uni.class" class="dem-edi-pro-tab-item-editar--valor_uni"
            :cpntStatus='campos.valor_uni.status'
            :cpntId='campos.valor_uni.id'
            :cpntAlerta='campos.valor_uni.alerta'
            :cpntTabIndex='campos.valor_uni.tabIndex'
            :cpntNome='campos.valor_uni.nome'
            :cpntValue='campos.valor_uni.value'
            :cpntMensagem='campos.valor_uni.mensagem'
            :cpntMensagemTipo='campos.valor_uni.mensagemTipo'
            :cpntDisabled='campos.valor_uni.disabled()'
            :cpntMostrar='campos.valor_uni.mostrar'
            :cpntExplica='campos.valor_uni.explica'
            :cpntPlaceholder='campos.valor_uni.placeholder'
            :cpntValueRef='campos.valor_uni.valueRef'
            :cpntRouter='campos.valor_uni.router'
            :cpntField='campos.valor_uni.field'
            :cpntWhere='campos.valor_uni.where'
            :cpntAddButForm='campos.valor_uni.addButForm'
            :cpntKeyMostra='campos.valor_uni.keyMostra'
            :cpntTipoOrder='campos.valor_uni.tipoOrder'
            :cpntOrder='campos.valor_uni.order'
            :cpntOptions='campos.valor_uni.options'
            :cpntKeyValue='campos.valor_uni.keyValue'
            :cpntSearchMinimo='campos.valor_uni.searchMinimo'
            :cpntMask='campos.valor_uni.mask'

            :cpntOnChange='campos.valor_uni.onChange'
            :cpntOnBlur='campos.valor_uni.onBlur'
            :cpntOnRealizaBusca='campos.valor_uni.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_uni.onKeyPressEnter'
            ref="valor_uni"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.valor_tot.class" class="dem-edi-pro-tab-item-editar--valor_tot"
            :cpntStatus='campos.valor_tot.status'
            :cpntId='campos.valor_tot.id'
            :cpntAlerta='campos.valor_tot.alerta'
            :cpntTabIndex='campos.valor_tot.tabIndex'
            :cpntNome='campos.valor_tot.nome'
            :cpntValue='campos.valor_tot.value'
            :cpntMensagem='campos.valor_tot.mensagem'
            :cpntMensagemTipo='campos.valor_tot.mensagemTipo'
            :cpntDisabled='campos.valor_tot.disabled()'
            :cpntMostrar='campos.valor_tot.mostrar'
            :cpntExplica='campos.valor_tot.explica'
            :cpntPlaceholder='campos.valor_tot.placeholder'
            :cpntValueRef='campos.valor_tot.valueRef'
            :cpntRouter='campos.valor_tot.router'
            :cpntField='campos.valor_tot.field'
            :cpntWhere='campos.valor_tot.where'
            :cpntAddButForm='campos.valor_tot.addButForm'
            :cpntKeyMostra='campos.valor_tot.keyMostra'
            :cpntTipoOrder='campos.valor_tot.tipoOrder'
            :cpntOrder='campos.valor_tot.order'
            :cpntOptions='campos.valor_tot.options'
            :cpntKeyValue='campos.valor_tot.keyValue'
            :cpntSearchMinimo='campos.valor_tot.searchMinimo'
            :cpntMask='campos.valor_tot.mask'

            :cpntOnChange='campos.valor_tot.onChange'
            :cpntOnBlur='campos.valor_tot.onBlur'
            :cpntOnRealizaBusca='campos.valor_tot.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_tot.onKeyPressEnter'
            ref="valor_tot"
          ></App-Input>
        </div>

        <div v-if="[ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(dados.demanda_p_doc_tp) !== -1">
          <App-Input :data-time="time" :class="campos.valor_fre.class" class="dem-edi-pro-tab-item-editar--valor_fre"
            :cpntStatus='campos.valor_fre.status'
            :cpntId='campos.valor_fre.id'
            :cpntAlerta='campos.valor_fre.alerta'
            :cpntTabIndex='campos.valor_fre.tabIndex'
            :cpntNome='campos.valor_fre.nome'
            :cpntValue='campos.valor_fre.value'
            :cpntMensagem='campos.valor_fre.mensagem'
            :cpntMensagemTipo='campos.valor_fre.mensagemTipo'
            :cpntDisabled='campos.valor_fre.disabled()'
            :cpntMostrar='campos.valor_fre.mostrar'
            :cpntExplica='campos.valor_fre.explica'
            :cpntPlaceholder='campos.valor_fre.placeholder'
            :cpntValueRef='campos.valor_fre.valueRef'
            :cpntRouter='campos.valor_fre.router'
            :cpntField='campos.valor_fre.field'
            :cpntWhere='campos.valor_fre.where'
            :cpntAddButForm='campos.valor_fre.addButForm'
            :cpntKeyMostra='campos.valor_fre.keyMostra'
            :cpntTipoOrder='campos.valor_fre.tipoOrder'
            :cpntOrder='campos.valor_fre.order'
            :cpntOptions='campos.valor_fre.options'
            :cpntKeyValue='campos.valor_fre.keyValue'
            :cpntSearchMinimo='campos.valor_fre.searchMinimo'
            :cpntMask='campos.valor_fre.mask'

            :cpntOnChange='campos.valor_fre.onChange'
            :cpntOnBlur='campos.valor_fre.onBlur'
            :cpntOnRealizaBusca='campos.valor_fre.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_fre.onKeyPressEnter'
            ref="valor_fre"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.valor_seg.class" class="dem-edi-pro-tab-item-editar--valor_seg"
            :cpntStatus='campos.valor_seg.status'
            :cpntId='campos.valor_seg.id'
            :cpntAlerta='campos.valor_seg.alerta'
            :cpntTabIndex='campos.valor_seg.tabIndex'
            :cpntNome='campos.valor_seg.nome'
            :cpntValue='campos.valor_seg.value'
            :cpntMensagem='campos.valor_seg.mensagem'
            :cpntMensagemTipo='campos.valor_seg.mensagemTipo'
            :cpntDisabled='campos.valor_seg.disabled()'
            :cpntMostrar='campos.valor_seg.mostrar'
            :cpntExplica='campos.valor_seg.explica'
            :cpntPlaceholder='campos.valor_seg.placeholder'
            :cpntValueRef='campos.valor_seg.valueRef'
            :cpntRouter='campos.valor_seg.router'
            :cpntField='campos.valor_seg.field'
            :cpntWhere='campos.valor_seg.where'
            :cpntAddButForm='campos.valor_seg.addButForm'
            :cpntKeyMostra='campos.valor_seg.keyMostra'
            :cpntTipoOrder='campos.valor_seg.tipoOrder'
            :cpntOrder='campos.valor_seg.order'
            :cpntOptions='campos.valor_seg.options'
            :cpntKeyValue='campos.valor_seg.keyValue'
            :cpntSearchMinimo='campos.valor_seg.searchMinimo'
            :cpntMask='campos.valor_seg.mask'

            :cpntOnChange='campos.valor_seg.onChange'
            :cpntOnBlur='campos.valor_seg.onBlur'
            :cpntOnRealizaBusca='campos.valor_seg.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_seg.onKeyPressEnter'
            ref="valor_seg"
          ></App-Input>

          <div :data-time="time" class="app-cpnt-field dem-edi-pro-tab-item-editar--valor_des desconto">
            <App-Select :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_t" :class="campos.valor_des_t.class"
            :cpntStatus='campos.valor_des_t.status'
            :cpntId='campos.valor_des_t.id'
            :cpntTabIndex='campos.valor_des_t.tabIndex'
            :cpntNome='campos.valor_des_t.nome'
            :cpntValue='campos.valor_des_t.value'
            :cpntMensagem='campos.valor_des_t.mensagem'
            :cpntMensagemTipo='campos.valor_des_t.mensagemTipo'
            :cpntDisabled='campos.valor_des_t.disabled()'
            :cpntMostrar='campos.valor_des_t.mostrar'
            :cpntExplica='campos.valor_des_t.explica'
            :cpntPlaceholder='campos.valor_des_t.placeholder'
            :cpntValueRef='campos.valor_des_t.valueRef'
            :cpntRouter='campos.valor_des_t.router'
            :cpntMethod='campos.valor_des_t.method'
            :cpntField='campos.valor_des_t.field'
            :cpntWhere='campos.valor_des_t.where'
            :cpntAddButForm='campos.valor_des_t.addButForm'
            :cpntKeyMostra='campos.valor_des_t.keyMostra'
            :cpntTipoOrder='campos.valor_des_t.tipoOrder'
            :cpntOrder='campos.valor_des_t.order'
            :cpntOptions='campos.valor_des_t.options'
            :cpntKeyValue='campos.valor_des_t.keyValue'
            :cpntSearchMinimo='campos.valor_des_t.searchMinimo'
            :cpntMask='campos.valor_des_t.mask'
            :cpntOptionInicialNome='campos.valor_des_t.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_t.optionInicialValue'
            :cpntOnBuscarOptions='campos.valor_des_t.onBuscarOptions'
            :cpntOnChange='campos.valor_des_t.onChange'
            :cpntOnBlur='campos.valor_des_t.onBlur'
            :cpntOnRealizaBusca='campos.valor_des_t.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_des_t.onKeyPressEnter'
            ref="valor_des_t"
            ></App-Select>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_p" :class="campos.valor_des_p.class" v-if="demEdiProTabItemEditarValorTipoDesconto === '%'"
            :cpntStatus='campos.valor_des_p.status'
            :cpntId='campos.valor_des_p.id'
            :cpntClassDivField='campos.valor_des_p.classDivField'
            :cpntNome='campos.valor_des_p.nome'
            :cpntValue='campos.valor_des_p.value'
            :cpntAutoComplete='campos.valor_des_p.autocomplete'
            :cpntMask='campos.valor_des_p.mask'
            :cpntOptionInicialNome='campos.valor_des_p.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_p.optionInicialValue'
            :cpntDisabled='campos.valor_des_p.disabled()'
            :cpntMostrar='campos.valor_des_p.mostrar'
            :cpntAutoFocus='campos.valor_des_p.autofocus'
            :cpntMensagem='campos.valor_des_p.mensagem'
            :cpntMensagemTipo='campos.valor_des_p.mensagemTipo'
            :cpntPlaceholder='campos.valor_des_p.placeholder'
            :cpntPosicionar='campos.valor_des_p.posicionar'
            :cpntOnChange='campos.valor_des_p.onChange'
            :cpntOnBlur='campos.valor_des_p.onBlur'
            ref='valor_des_p'
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_v" :class="campos.valor_des_v.class" v-if="demEdiProTabItemEditarValorTipoDesconto === 'R$'"
            :cpntStatus='campos.valor_des_v.status'
            :cpntId='campos.valor_des_v.id'
            :cpntClassDivField='campos.valor_des_v.classDivField'
            :cpntNome='campos.valor_des_v.nome'
            :cpntValue='campos.valor_des_v.value'
            :cpntAutoComplete='campos.valor_des_v.autocomplete'
            :cpntMask='campos.valor_des_v.mask'
            :cpntOptionInicialNome='campos.valor_des_v.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_v.optionInicialValue'
            :cpntDisabled='campos.valor_des_v.disabled()'
            :cpntMostrar='campos.valor_des_v.mostrar'
            :cpntAutoFocus='campos.valor_des_v.autofocus'
            :cpntMensagem='campos.valor_des_v.mensagem'
            :cpntMensagemTipo='campos.valor_des_v.mensagemTipo'
            :cpntPlaceholder='campos.valor_des_v.placeholder'
            :cpntPosicionar='campos.valor_des_v.posicionar'
            :cpntOnChange='campos.valor_des_v.onChange'
            :cpntOnBlur='campos.valor_des_v.onBlur'
            ref='valor_des_v'
            ></App-Input>
          </div>

          <App-Input :data-time="time" :class="campos.valor_oda.class" class="dem-edi-pro-tab-item-editar--valor_oda"
            :cpntStatus='campos.valor_oda.status'
            :cpntId='campos.valor_oda.id'
            :cpntAlerta='campos.valor_oda.alerta'
            :cpntTabIndex='campos.valor_oda.tabIndex'
            :cpntNome='campos.valor_oda.nome'
            :cpntValue='campos.valor_oda.value'
            :cpntMensagem='campos.valor_oda.mensagem'
            :cpntMensagemTipo='campos.valor_oda.mensagemTipo'
            :cpntDisabled='campos.valor_oda.disabled()'
            :cpntMostrar='campos.valor_oda.mostrar'
            :cpntExplica='campos.valor_oda.explica'
            :cpntPlaceholder='campos.valor_oda.placeholder'
            :cpntValueRef='campos.valor_oda.valueRef'
            :cpntRouter='campos.valor_oda.router'
            :cpntField='campos.valor_oda.field'
            :cpntWhere='campos.valor_oda.where'
            :cpntAddButForm='campos.valor_oda.addButForm'
            :cpntKeyMostra='campos.valor_oda.keyMostra'
            :cpntTipoOrder='campos.valor_oda.tipoOrder'
            :cpntOrder='campos.valor_oda.order'
            :cpntOptions='campos.valor_oda.options'
            :cpntKeyValue='campos.valor_oda.keyValue'
            :cpntSearchMinimo='campos.valor_oda.searchMinimo'
            :cpntMask='campos.valor_oda.mask'

            :cpntOnChange='campos.valor_oda.onChange'
            :cpntOnBlur='campos.valor_oda.onBlur'
            :cpntOnRealizaBusca='campos.valor_oda.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_oda.onKeyPressEnter'
            ref="valor_oda"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.sub_total.class" class="dem-edi-pro-tab-item-editar--sub_total"
            :cpntStatus='campos.sub_total.status'
            :cpntId='campos.sub_total.id'
            :cpntAlerta='campos.sub_total.alerta'
            :cpntTabIndex='campos.sub_total.tabIndex'
            :cpntNome='campos.sub_total.nome'
            :cpntValue='campos.sub_total.value'
            :cpntMensagem='campos.sub_total.mensagem'
            :cpntMensagemTipo='campos.sub_total.mensagemTipo'
            :cpntDisabled='campos.sub_total.disabled()'
            :cpntMostrar='campos.sub_total.mostrar'
            :cpntExplica='campos.sub_total.explica'
            :cpntPlaceholder='campos.sub_total.placeholder'
            :cpntValueRef='campos.sub_total.valueRef'
            :cpntRouter='campos.sub_total.router'
            :cpntField='campos.sub_total.field'
            :cpntWhere='campos.sub_total.where'
            :cpntAddButForm='campos.sub_total.addButForm'
            :cpntKeyMostra='campos.sub_total.keyMostra'
            :cpntTipoOrder='campos.sub_total.tipoOrder'
            :cpntOrder='campos.sub_total.order'
            :cpntOptions='campos.sub_total.options'
            :cpntKeyValue='campos.sub_total.keyValue'
            :cpntSearchMinimo='campos.sub_total.searchMinimo'
            :cpntMask='campos.sub_total.mask'

            :cpntOnChange='campos.sub_total.onChange'
            :cpntOnBlur='campos.sub_total.onBlur'
            :cpntOnRealizaBusca='campos.sub_total.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.sub_total.onKeyPressEnter'
            ref="sub_total"
          ></App-Input>
        </div>

        <div v-else class="p_doc_manual">
          <div :data-time="time" class="app-cpnt-field dem-edi-pro-tab-item-editar--valor_des desconto">
            <App-Select :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_t" :class="campos.valor_des_t.class"
            :cpntStatus='campos.valor_des_t.status'
            :cpntId='campos.valor_des_t.id'
            :cpntTabIndex='campos.valor_des_t.tabIndex'
            :cpntNome='campos.valor_des_t.nome'
            :cpntValue='campos.valor_des_t.value'
            :cpntMensagem='campos.valor_des_t.mensagem'
            :cpntMensagemTipo='campos.valor_des_t.mensagemTipo'
            :cpntDisabled='campos.valor_des_t.disabled()'
            :cpntMostrar='campos.valor_des_t.mostrar'
            :cpntExplica='campos.valor_des_t.explica'
            :cpntPlaceholder='campos.valor_des_t.placeholder'
            :cpntValueRef='campos.valor_des_t.valueRef'
            :cpntRouter='campos.valor_des_t.router'
            :cpntMethod='campos.valor_des_t.method'
            :cpntField='campos.valor_des_t.field'
            :cpntWhere='campos.valor_des_t.where'
            :cpntAddButForm='campos.valor_des_t.addButForm'
            :cpntKeyMostra='campos.valor_des_t.keyMostra'
            :cpntTipoOrder='campos.valor_des_t.tipoOrder'
            :cpntOrder='campos.valor_des_t.order'
            :cpntOptions='campos.valor_des_t.options'
            :cpntKeyValue='campos.valor_des_t.keyValue'
            :cpntSearchMinimo='campos.valor_des_t.searchMinimo'
            :cpntMask='campos.valor_des_t.mask'
            :cpntOptionInicialNome='campos.valor_des_t.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_t.optionInicialValue'
            :cpntOnBuscarOptions='campos.valor_des_t.onBuscarOptions'
            :cpntOnChange='campos.valor_des_t.onChange'
            :cpntOnBlur='campos.valor_des_t.onBlur'
            :cpntOnRealizaBusca='campos.valor_des_t.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_des_t.onKeyPressEnter'
            ref="valor_des_t"
            ></App-Select>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_p" :class="campos.valor_des_p.class" v-if="demEdiProTabItemEditarValorTipoDesconto === '%'"
            :cpntStatus='campos.valor_des_p.status'
            :cpntId='campos.valor_des_p.id'
            :cpntClassDivField='campos.valor_des_p.classDivField'
            :cpntNome='campos.valor_des_p.nome'
            :cpntValue='campos.valor_des_p.value'
            :cpntAutoComplete='campos.valor_des_p.autocomplete'
            :cpntMask='campos.valor_des_p.mask'
            :cpntOptionInicialNome='campos.valor_des_p.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_p.optionInicialValue'
            :cpntDisabled='campos.valor_des_p.disabled()'
            :cpntMostrar='campos.valor_des_p.mostrar'
            :cpntAutoFocus='campos.valor_des_p.autofocus'
            :cpntMensagem='campos.valor_des_p.mensagem'
            :cpntMensagemTipo='campos.valor_des_p.mensagemTipo'
            :cpntPlaceholder='campos.valor_des_p.placeholder'
            :cpntPosicionar='campos.valor_des_p.posicionar'
            :cpntOnChange='campos.valor_des_p.onChange'
            :cpntOnBlur='campos.valor_des_p.onBlur'
            ref='valor_des_p'
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des_v" :class="campos.valor_des_v.class" v-if="demEdiProTabItemEditarValorTipoDesconto === 'R$'"
            :cpntStatus='campos.valor_des_v.status'
            :cpntId='campos.valor_des_v.id'
            :cpntClassDivField='campos.valor_des_v.classDivField'
            :cpntNome='campos.valor_des_v.nome'
            :cpntValue='campos.valor_des_v.value'
            :cpntAutoComplete='campos.valor_des_v.autocomplete'
            :cpntMask='campos.valor_des_v.mask'
            :cpntOptionInicialNome='campos.valor_des_v.optionInicialNome'
            :cpntOptionInicialValue='campos.valor_des_v.optionInicialValue'
            :cpntDisabled='campos.valor_des_v.disabled()'
            :cpntMostrar='campos.valor_des_v.mostrar'
            :cpntAutoFocus='campos.valor_des_v.autofocus'
            :cpntMensagem='campos.valor_des_v.mensagem'
            :cpntMensagemTipo='campos.valor_des_v.mensagemTipo'
            :cpntPlaceholder='campos.valor_des_v.placeholder'
            :cpntPosicionar='campos.valor_des_v.posicionar'
            :cpntOnChange='campos.valor_des_v.onChange'
            :cpntOnBlur='campos.valor_des_v.onBlur'
            ref='valor_des_v'
            ></App-Input>
          </div>

          <App-Input :data-time="time" :class="campos.p_ipi_v.class" class="dem-edi-pro-tab-item-editar--p_ipi_v"
            :cpntStatus='campos.p_ipi_v.status'
            :cpntId='campos.p_ipi_v.id'
            :cpntAlerta='campos.p_ipi_v.alerta'
            :cpntTabIndex='campos.p_ipi_v.tabIndex'
            :cpntNome='"Valor IPI"'
            :cpntValue='campos.p_ipi_v.value'
            :cpntMensagem='campos.p_ipi_v.mensagem'
            :cpntMensagemTipo='campos.p_ipi_v.mensagemTipo'
            :cpntDisabled='campos.p_ipi_v.disabled()'
            :cpntMostrar='campos.p_ipi_v.mostrar'
            :cpntPlaceholder='campos.p_ipi_v.placeholder'
            :cpntValueRef='campos.p_ipi_v.valueRef'
            :cpntRouter='campos.p_ipi_v.router'
            :cpntField='campos.p_ipi_v.field'
            :cpntWhere='campos.p_ipi_v.where'
            :cpntAddButForm='campos.p_ipi_v.addButForm'
            :cpntKeyMostra='campos.p_ipi_v.keyMostra'
            :cpntTipoOrder='campos.p_ipi_v.tipoOrder'
            :cpntOrder='campos.p_ipi_v.order'
            :cpntOptions='campos.p_ipi_v.options'
            :cpntKeyValue='campos.p_ipi_v.keyValue'
            :cpntSearchMinimo='campos.p_ipi_v.searchMinimo'
            :cpntMask='campos.p_ipi_v.mask'

            :cpntOnChange='campos.p_ipi_v.onChange'
            :cpntOnBlur='campos.p_ipi_v.onBlur'
            :cpntOnRealizaBusca='campos.p_ipi_v.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.p_ipi_v.onKeyPressEnter'
            ref="p_ipi_v"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.p_icms_st_v.class" class="dem-edi-pro-tab-item-editar--p_icms_st_v"
            :cpntStatus='campos.p_icms_st_v.status'
            :cpntId='campos.p_icms_st_v.id'
            :cpntAlerta='campos.p_icms_st_v.alerta'
            :cpntTabIndex='campos.p_icms_st_v.tabIndex'
            :cpntNome='"Valor ICMS ST"'
            :cpntValue='campos.p_icms_st_v.value'
            :cpntMensagem='campos.p_icms_st_v.mensagem'
            :cpntMensagemTipo='campos.p_icms_st_v.mensagemTipo'
            :cpntDisabled='campos.p_icms_st_v.disabled()'
            :cpntMostrar='campos.p_icms_st_v.mostrar'
            :cpntExplica='campos.p_icms_st_v.explica'
            :cpntPlaceholder='campos.p_icms_st_v.placeholder'
            :cpntValueRef='campos.p_icms_st_v.valueRef'
            :cpntRouter='campos.p_icms_st_v.router'
            :cpntField='campos.p_icms_st_v.field'
            :cpntWhere='campos.p_icms_st_v.where'
            :cpntAddButForm='campos.p_icms_st_v.addButForm'
            :cpntKeyMostra='campos.p_icms_st_v.keyMostra'
            :cpntTipoOrder='campos.p_icms_st_v.tipoOrder'
            :cpntOrder='campos.p_icms_st_v.order'
            :cpntOptions='campos.p_icms_st_v.options'
            :cpntKeyValue='campos.p_icms_st_v.keyValue'
            :cpntSearchMinimo='campos.p_icms_st_v.searchMinimo'
            :cpntMask='campos.p_icms_st_v.mask'

            :cpntOnChange='campos.p_icms_st_v.onChange'
            :cpntOnBlur='campos.p_icms_st_v.onBlur'
            :cpntOnRealizaBusca='campos.p_icms_st_v.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.p_icms_st_v.onKeyPressEnter'
            ref="p_icms_st_v"
          ></App-Input>

          <App-Input :data-time="time" :class="campos.sub_total.class" class="dem-edi-pro-tab-item-editar--sub_total"
            :cpntStatus='campos.sub_total.status'
            :cpntId='campos.sub_total.id'
            :cpntAlerta='campos.sub_total.alerta'
            :cpntTabIndex='campos.sub_total.tabIndex'
            :cpntNome='campos.sub_total.nome'
            :cpntValue='campos.sub_total.value'
            :cpntMensagem='campos.sub_total.mensagem'
            :cpntMensagemTipo='campos.sub_total.mensagemTipo'
            :cpntDisabled='campos.sub_total.disabled()'
            :cpntMostrar='campos.sub_total.mostrar'
            :cpntExplica='campos.sub_total.explica'
            :cpntPlaceholder='campos.sub_total.placeholder'
            :cpntValueRef='campos.sub_total.valueRef'
            :cpntRouter='campos.sub_total.router'
            :cpntField='campos.sub_total.field'
            :cpntWhere='campos.sub_total.where'
            :cpntAddButForm='campos.sub_total.addButForm'
            :cpntKeyMostra='campos.sub_total.keyMostra'
            :cpntTipoOrder='campos.sub_total.tipoOrder'
            :cpntOrder='campos.sub_total.order'
            :cpntOptions='campos.sub_total.options'
            :cpntKeyValue='campos.sub_total.keyValue'
            :cpntSearchMinimo='campos.sub_total.searchMinimo'
            :cpntMask='campos.sub_total.mask'

            :cpntOnChange='campos.sub_total.onChange'
            :cpntOnBlur='campos.sub_total.onBlur'
            :cpntOnRealizaBusca='campos.sub_total.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.sub_total.onKeyPressEnter'
            ref="sub_total"
          ></App-Input>
        </div>

        <div v-if="[ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(dados.demanda_p_doc_tp) !== -1">
          <!-- <div class="dem-edi-pro-tab-item-editar--p_id_caso">
            <App-Select :data-time="time"
              :cpntStatus='campos.p_id_caso.status'
              :cpntId='campos.p_id_caso.id'
              :cpntAlerta='campos.p_id_caso.alerta'
              :cpntTabIndex='campos.p_id_caso.tabIndex'
              :cpntNome='campos.p_id_caso.nome'
              :cpntValue='campos.p_id_caso.value'
              :cpntMensagem='campos.p_id_caso.mensagem'
              :cpntMensagemTipo='campos.p_id_caso.mensagemTipo'
              :cpntDisabled='campos.p_id_caso.disabled()'
              :cpntMostrar='campos.p_id_caso.mostrar'
              :cpntExplica='campos.p_id_caso.explica'
              :cpntPlaceholder='campos.p_id_caso.placeholder'
              :cpntValueRef='campos.p_id_caso.valueRef'
              :cpntRouter='campos.p_id_caso.router'
              :cpntField='campos.p_id_caso.field'
              :cpntWhere='campos.p_id_caso.where'
              :cpntAddButForm='campos.p_id_caso.addButForm'
              :cpntKeyMostra='campos.p_id_caso.keyMostra'
              :cpntTipoOrder='campos.p_id_caso.tipoOrder'
              :cpntOrder='campos.p_id_caso.order'
              :cpntOptions='campos.p_id_caso.options'
              :cpntOptionInicialNome='campos.p_id_caso.optionInicialNome'
              :cpntOptionInicialValue='campos.p_id_caso.optionInicialValue'
              :cpntKeyValue='campos.p_id_caso.keyValue'
              :cpntSearchMinimo='campos.p_id_caso.searchMinimo'
              :cpntMask='campos.p_id_caso.mask'

              :cpntOnBuscarOptions='campos.p_id_caso.onBuscarOptions'
              :cpntOnChange='campos.p_id_caso.onChange'
              :cpntOnBlur='campos.p_id_caso.onBlur'
              :cpntOnRealizaBusca='campos.p_id_caso.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_id_caso.onKeyPressEnter'
              ref="p_id_caso"
            ></App-Select>
          </div> -->

          <div class="dem-edi-pro-tab-item-editar--p_id_cfop">
            <App-Select :data-time="time" :class="campos.p_id_cfop.class" class="dem-edi-pro-tab-item-editar--p_id_cfop"
              :cpntStatus='campos.p_id_cfop.status'
              :cpntId='campos.p_id_cfop.id'
              :cpntAlerta='campos.p_id_cfop.alerta'
              :cpntTabIndex='campos.p_id_cfop.tabIndex'
              :cpntNome='campos.p_id_cfop.nome'
              :cpntValue='campos.p_id_cfop.value'
              :cpntMensagem='campos.p_id_cfop.mensagem'
              :cpntMensagemTipo='campos.p_id_cfop.mensagemTipo'
              :cpntDisabled='campos.p_id_cfop.disabled()'
              :cpntMostrar='campos.p_id_cfop.mostrar'
              :cpntExplica='campos.p_id_cfop.explica'
              :cpntPlaceholder='campos.p_id_cfop.placeholder'
              :cpntValueRef='campos.p_id_cfop.valueRef'
              :cpntRouter='campos.p_id_cfop.router'
              :cpntField='campos.p_id_cfop.field'
              :cpntWhere='campos.p_id_cfop.where'
              :cpntAddButForm='campos.p_id_cfop.addButForm'
              :cpntKeyMostra='campos.p_id_cfop.keyMostra'
              :cpntTipoOrder='campos.p_id_cfop.tipoOrder'
              :cpntOrder='campos.p_id_cfop.order'
              :cpntOptions='campos.p_id_cfop.options'
              :cpntOptionInicialNome='campos.p_id_cfop.optionInicialNome'
              :cpntOptionInicialValue='campos.p_id_cfop.optionInicialValue'
              :cpntKeyValue='campos.p_id_cfop.keyValue'
              :cpntSearchMinimo='campos.p_id_cfop.searchMinimo'
              :cpntMask='campos.p_id_cfop.mask'

              :cpntOnBuscarOptions='campos.p_id_cfop.onBuscarOptions'
              :cpntOnChange='campos.p_id_cfop.onChange'
              :cpntOnBlur='campos.p_id_cfop.onBlur'
              :cpntOnRealizaBusca='campos.p_id_cfop.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_id_cfop.onKeyPressEnter'
              ref="p_id_cfop"
            ></App-Select>
          </div>
        </div>
      </div>

      <template v-if="[ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(dados.demanda_p_doc_tp) !== -1">
        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          ICMS
        </div>
        <div class="quadrado">
          <div>
            <div class="dem-edi-pro-tab-item-editar--p_icms_origem">
              <App-Select :data-time="time" :class="campos.p_icms_origem.class" class="dem-edi-pro-tab-item-editar--p_icms_origem"
                :cpntStatus='campos.p_icms_origem.status'
                :cpntId='campos.p_icms_origem.id'
                :cpntAlerta='campos.p_icms_origem.alerta'
                :cpntTabIndex='campos.p_icms_origem.tabIndex'
                :cpntNome='campos.p_icms_origem.nome'
                :cpntValue='campos.p_icms_origem.value'
                :cpntMensagem='campos.p_icms_origem.mensagem'
                :cpntMensagemTipo='campos.p_icms_origem.mensagemTipo'
                :cpntDisabled='campos.p_icms_origem.disabled()'
                :cpntMostrar='campos.p_icms_origem.mostrar'
                :cpntExplica='campos.p_icms_origem.explica'
                :cpntPlaceholder='campos.p_icms_origem.placeholder'
                :cpntValueRef='campos.p_icms_origem.valueRef'
                :cpntRouter='campos.p_icms_origem.router'
                :cpntField='campos.p_icms_origem.field'
                :cpntWhere='campos.p_icms_origem.where'
                :cpntAddButForm='campos.p_icms_origem.addButForm'
                :cpntKeyMostra='campos.p_icms_origem.keyMostra'
                :cpntTipoOrder='campos.p_icms_origem.tipoOrder'
                :cpntOrder='campos.p_icms_origem.order'
                :cpntOptions='campos.p_icms_origem.options'
                :cpntOptionInicialNome='campos.p_icms_origem.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_origem.optionInicialValue'
                :cpntKeyValue='campos.p_icms_origem.keyValue'
                :cpntSearchMinimo='campos.p_icms_origem.searchMinimo'
                :cpntMask='campos.p_icms_origem.mask'

                :cpntOnBuscarOptions='campos.p_icms_origem.onBuscarOptions'
                :cpntOnChange='campos.p_icms_origem.onChange'
                :cpntOnBlur='campos.p_icms_origem.onBlur'
                :cpntOnRealizaBusca='campos.p_icms_origem.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_icms_origem.onKeyPressEnter'
                ref="p_icms_origem"
              ></App-Select>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_cst">
              <App-Select :data-time="time" :class="campos.p_icms_cst.class" class="dem-edi-pro-tab-item-editar--p_icms_cst"
                :cpntStatus='campos.p_icms_cst.status'
                :cpntId='campos.p_icms_cst.id'
                :cpntAlerta='campos.p_icms_cst.alerta'
                :cpntTabIndex='campos.p_icms_cst.tabIndex'
                :cpntNome='demEdiProTabItemEditarGerarNomeCstIcms'
                :cpntValue='campos.p_icms_cst.value'
                :cpntMensagem='campos.p_icms_cst.mensagem'
                :cpntMensagemTipo='campos.p_icms_cst.mensagemTipo'
                :cpntDisabled='campos.p_icms_cst.disabled()'
                :cpntMostrar='campos.p_icms_cst.mostrar'
                :cpntExplica='campos.p_icms_cst.explica'
                :cpntPlaceholder='campos.p_icms_cst.placeholder'
                :cpntValueRef='campos.p_icms_cst.valueRef'
                :cpntRouter='campos.p_icms_cst.router'
                :cpntField='campos.p_icms_cst.field'
                :cpntWhere='campos.p_icms_cst.where'
                :cpntAddButForm='campos.p_icms_cst.addButForm'
                :cpntKeyMostra='campos.p_icms_cst.keyMostra'
                :cpntTipoOrder='campos.p_icms_cst.tipoOrder'
                :cpntOrder='campos.p_icms_cst.order'
                :cpntOptions='campos.p_icms_cst.options'
                :cpntOptionInicialNome='campos.p_icms_cst.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_cst.optionInicialValue'
                :cpntKeyValue='campos.p_icms_cst.keyValue'
                :cpntSearchMinimo='campos.p_icms_cst.searchMinimo'
                :cpntMask='campos.p_icms_cst.mask'

                :cpntOnBuscarOptions='campos.p_icms_cst.onBuscarOptions'
                :cpntOnChange='campos.p_icms_cst.onChange'
                :cpntOnBlur='campos.p_icms_cst.onBlur'
                :cpntOnRealizaBusca='campos.p_icms_cst.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_icms_cst.onKeyPressEnter'
                ref="p_icms_cst"
              ></App-Select>
            </div>
          </div>

          <div style="padding-top: 25px">
            <div class="dem-edi-pro-tab-item-editar--p_icms_bc_mod">
              <App-Select :data-time="time" :class="campos.p_icms_bc_mod.class" class="dem-edi-pro-tab-item-editar--p_icms_bc_mod"
                :cpntStatus='campos.p_icms_bc_mod.status'
                :cpntId='campos.p_icms_bc_mod.id'
                :cpntAlerta='campos.p_icms_bc_mod.alerta'
                :cpntTabIndex='campos.p_icms_bc_mod.tabIndex'
                :cpntNome='campos.p_icms_bc_mod.nome'
                :cpntValue='campos.p_icms_bc_mod.value'
                :cpntMensagem='campos.p_icms_bc_mod.mensagem'
                :cpntMensagemTipo='campos.p_icms_bc_mod.mensagemTipo'
                :cpntDisabled='campos.p_icms_bc_mod.disabled() === true'
                :cpntMostrar='campos.p_icms_bc_mod.mostrar'
                :cpntExplica='campos.p_icms_bc_mod.explica'
                :cpntPlaceholder='campos.p_icms_bc_mod.placeholder'
                :cpntValueRef='campos.p_icms_bc_mod.valueRef'
                :cpntRouter='campos.p_icms_bc_mod.router'
                :cpntField='campos.p_icms_bc_mod.field'
                :cpntWhere='campos.p_icms_bc_mod.where'
                :cpntAddButForm='campos.p_icms_bc_mod.addButForm'
                :cpntKeyMostra='campos.p_icms_bc_mod.keyMostra'
                :cpntTipoOrder='campos.p_icms_bc_mod.tipoOrder'
                :cpntOrder='campos.p_icms_bc_mod.order'
                :cpntOptions='campos.p_icms_bc_mod.options'
                :cpntOptionInicialNome='campos.p_icms_bc_mod.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_bc_mod.optionInicialValue'
                :cpntKeyValue='campos.p_icms_bc_mod.keyValue'
                :cpntSearchMinimo='campos.p_icms_bc_mod.searchMinimo'
                :cpntMask='campos.p_icms_bc_mod.mask'

                :cpntOnBuscarOptions='campos.p_icms_bc_mod.onBuscarOptions'
                :cpntOnChange='campos.p_icms_bc_mod.onChange'
                :cpntOnBlur='campos.p_icms_bc_mod.onBlur'
                :cpntOnRealizaBusca='campos.p_icms_bc_mod.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_icms_bc_mod.onKeyPressEnter'
                ref="p_icms_bc_mod"
              ></App-Select>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_bc_v">
              <App-Input :data-time="time" :class="campos.p_icms_bc_v.class" class="dem-edi-pro-tab-item-editar--p_icms_bc_v"
                :cpntStatus='campos.p_icms_bc_v.status'
                :cpntId='campos.p_icms_bc_v.id'
                :cpntAlerta='campos.p_icms_bc_v.alerta'
                :cpntClassDivField='campos.p_icms_bc_v.classDivField'
                :cpntNome='campos.p_icms_bc_v.nome'
                :cpntValue='campos.p_icms_bc_v.value'
                :cpntAutoComplete='campos.p_icms_bc_v.autocomplete'
                :cpntMask='campos.p_icms_bc_v.mask'
                :cpntOptionInicialNome='campos.p_icms_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_bc_v.disabled()'
                :cpntMostrar='campos.p_icms_bc_v.mostrar'
                :cpntExplica='campos.p_icms_bc_v.explica'
                :cpntAutoFocus='campos.p_icms_bc_v.autofocus'
                :cpntMensagem='campos.p_icms_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_bc_v.placeholder'
                :cpntPosicionar='campos.p_icms_bc_v.posicionar'
                :cpntOnChange='campos.p_icms_bc_v.onChange'
                :cpntOnBlur='campos.p_icms_bc_v.onBlur'
                ref='p_icms_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_a">
              <App-Input :data-time="time" :class="campos.p_icms_a.class" class="dem-edi-pro-tab-item-editar--p_icms_a"
                :cpntStatus='campos.p_icms_a.status'
                :cpntId='campos.p_icms_a.id'
                :cpntAlerta='campos.p_icms_a.alerta'
                :cpntClassDivField='campos.p_icms_a.classDivField'
                :cpntNome='campos.p_icms_a.nome'
                :cpntValue='campos.p_icms_a.value'
                :cpntAutoComplete='campos.p_icms_a.autocomplete'
                :cpntMask='campos.p_icms_a.mask'
                :cpntOptionInicialNome='campos.p_icms_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_a.optionInicialValue'
                :cpntDisabled='campos.p_icms_a.disabled()'
                :cpntMostrar='campos.p_icms_a.mostrar'
                :cpntExplica='campos.p_icms_a.explica'
                :cpntAutoFocus='campos.p_icms_a.autofocus'
                :cpntMensagem='campos.p_icms_a.mensagem'
                :cpntMensagemTipo='campos.p_icms_a.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_a.placeholder'
                :cpntPosicionar='campos.p_icms_a.posicionar'
                :cpntOnChange='campos.p_icms_a.onChange'
                :cpntOnBlur='campos.p_icms_a.onBlur'
                ref='p_icms_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r">
              <App-Input :data-time="time" :class="campos.p_icms_bc_p_r.class" class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r"
                :cpntStatus='campos.p_icms_bc_p_r.status'
                :cpntId='campos.p_icms_bc_p_r.id'
                :cpntAlerta='campos.p_icms_bc_p_r.alerta'
                :cpntClassDivField='campos.p_icms_bc_p_r.classDivField'
                :cpntNome='campos.p_icms_bc_p_r.nome'
                :cpntValue='campos.p_icms_bc_p_r.value'
                :cpntAutoComplete='campos.p_icms_bc_p_r.autocomplete'
                :cpntMask='campos.p_icms_bc_p_r.mask'
                :cpntOptionInicialNome='campos.p_icms_bc_p_r.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_bc_p_r.optionInicialValue'
                :cpntDisabled='campos.p_icms_bc_p_r.disabled()'
                :cpntMostrar='campos.p_icms_bc_p_r.mostrar'
                :cpntExplica='campos.p_icms_bc_p_r.explica'
                :cpntAutoFocus='campos.p_icms_bc_p_r.autofocus'
                :cpntMensagem='campos.p_icms_bc_p_r.mensagem'
                :cpntMensagemTipo='campos.p_icms_bc_p_r.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_bc_p_r.placeholder'
                :cpntPosicionar='campos.p_icms_bc_p_r.posicionar'
                :cpntOnChange='campos.p_icms_bc_p_r.onChange'
                :cpntOnBlur='campos.p_icms_bc_p_r.onBlur'
                ref='p_icms_bc_p_r'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c">
              <App-Select :data-time="time" :class="campos.p_icms_bc_p_r_c.class" class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c"
                :cpntStatus='campos.p_icms_bc_p_r_c.status'
                :cpntId='campos.p_icms_bc_p_r_c.id'
                :cpntAlerta='campos.p_icms_bc_p_r_c.alerta'
                :cpntTabIndex='campos.p_icms_bc_p_r_c.tabIndex'
                :cpntNome='campos.p_icms_bc_p_r_c.nome'
                :cpntValue='campos.p_icms_bc_p_r_c.value'
                :cpntMensagem='campos.p_icms_bc_p_r_c.mensagem'
                :cpntMensagemTipo='campos.p_icms_bc_p_r_c.mensagemTipo'
                :cpntDisabled='campos.p_icms_bc_p_r_c.disabled()'
                :cpntMostrar='campos.p_icms_bc_p_r_c.mostrar'
                :cpntExplica='campos.p_icms_bc_p_r_c.explica'
                :cpntPlaceholder='campos.p_icms_bc_p_r_c.placeholder'
                :cpntValueRef='campos.p_icms_bc_p_r_c.valueRef'
                :cpntRouter='campos.p_icms_bc_p_r_c.router'
                :cpntField='campos.p_icms_bc_p_r_c.field'
                :cpntWhere='campos.p_icms_bc_p_r_c.where'
                :cpntAddButForm='campos.p_icms_bc_p_r_c.addButForm'
                :cpntKeyMostra='campos.p_icms_bc_p_r_c.keyMostra'
                :cpntTipoOrder='campos.p_icms_bc_p_r_c.tipoOrder'
                :cpntOrder='campos.p_icms_bc_p_r_c.order'
                :cpntOptions='campos.p_icms_bc_p_r_c.options'
                :cpntOptionInicialNome='campos.p_icms_bc_p_r_c.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_bc_p_r_c.optionInicialValue'
                :cpntKeyValue='campos.p_icms_bc_p_r_c.keyValue'
                :cpntSearchMinimo='campos.p_icms_bc_p_r_c.searchMinimo'
                :cpntMask='campos.p_icms_bc_p_r_c.mask'

                :cpntOnBuscarOptions='campos.p_icms_bc_p_r_c.onBuscarOptions'
                :cpntOnChange='campos.p_icms_bc_p_r_c.onChange'
                :cpntOnBlur='campos.p_icms_bc_p_r_c.onBlur'
                :cpntOnRealizaBusca='campos.p_icms_bc_p_r_c.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_icms_bc_p_r_c.onKeyPressEnter'
                ref="p_icms_bc_p_r_c"
              ></App-Select>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_v">
              <App-Input :data-time="time" :class="campos.p_icms_v.class" class="dem-edi-pro-tab-item-editar--p_icms_v"
                :cpntStatus='campos.p_icms_v.status'
                :cpntId='campos.p_icms_v.id'
                :cpntAlerta='campos.p_icms_v.alerta'
                :cpntClassDivField='campos.p_icms_v.classDivField'
                :cpntNome='campos.p_icms_v.nome'
                :cpntValue='campos.p_icms_v.value'
                :cpntAutoComplete='campos.p_icms_v.autocomplete'
                :cpntMask='campos.p_icms_v.mask'
                :cpntOptionInicialNome='campos.p_icms_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_v.disabled()'
                :cpntMostrar='campos.p_icms_v.mostrar'
                :cpntExplica='campos.p_icms_v.explica'
                :cpntAutoFocus='campos.p_icms_v.autofocus'
                :cpntMensagem='campos.p_icms_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_v.placeholder'
                :cpntPosicionar='campos.p_icms_v.posicionar'
                :cpntOnChange='campos.p_icms_v.onChange'
                :cpntOnBlur='campos.p_icms_v.onBlur'
                ref='p_icms_v'
              ></App-Input>
            </div>
          </div>

          <div style="padding-top: 25px">
            <div class="dem-edi-pro-tab-item-editar--p_icms_st_bc_mod">
              <App-Select :data-time="time" :class="campos.p_icms_st_bc_mod.class" class="dem-edi-pro-tab-item-editar--p_icms_st_bc_mod"
                :cpntStatus='campos.p_icms_st_bc_mod.status'
                :cpntId='campos.p_icms_st_bc_mod.id'
                :cpntAlerta='campos.p_icms_st_bc_mod.alerta'
                :cpntTabIndex='campos.p_icms_st_bc_mod.tabIndex'
                :cpntNome='campos.p_icms_st_bc_mod.nome'
                :cpntValue='campos.p_icms_st_bc_mod.value'
                :cpntMensagem='campos.p_icms_st_bc_mod.mensagem'
                :cpntMensagemTipo='campos.p_icms_st_bc_mod.mensagemTipo'
                :cpntDisabled='campos.p_icms_st_bc_mod.disabled()'
                :cpntMostrar='campos.p_icms_st_bc_mod.mostrar'
                :cpntExplica='campos.p_icms_st_bc_mod.explica'
                :cpntPlaceholder='campos.p_icms_st_bc_mod.placeholder'
                :cpntValueRef='campos.p_icms_st_bc_mod.valueRef'
                :cpntRouter='campos.p_icms_st_bc_mod.router'
                :cpntField='campos.p_icms_st_bc_mod.field'
                :cpntWhere='campos.p_icms_st_bc_mod.where'
                :cpntAddButForm='campos.p_icms_st_bc_mod.addButForm'
                :cpntKeyMostra='campos.p_icms_st_bc_mod.keyMostra'
                :cpntTipoOrder='campos.p_icms_st_bc_mod.tipoOrder'
                :cpntOrder='campos.p_icms_st_bc_mod.order'
                :cpntOptions='campos.p_icms_st_bc_mod.options'
                :cpntOptionInicialNome='campos.p_icms_st_bc_mod.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_st_bc_mod.optionInicialValue'
                :cpntKeyValue='campos.p_icms_st_bc_mod.keyValue'
                :cpntSearchMinimo='campos.p_icms_st_bc_mod.searchMinimo'
                :cpntMask='campos.p_icms_st_bc_mod.mask'

                :cpntOnBuscarOptions='campos.p_icms_st_bc_mod.onBuscarOptions'
                :cpntOnChange='campos.p_icms_st_bc_mod.onChange'
                :cpntOnBlur='campos.p_icms_st_bc_mod.onBlur'
                :cpntOnRealizaBusca='campos.p_icms_st_bc_mod.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_icms_st_bc_mod.onKeyPressEnter'
                ref="p_icms_st_bc_mod"
              ></App-Select>
            </div>
            
            <div class="dem-edi-pro-tab-item-editar--p_icms_mva_p">
              <App-Input :data-time="time" :class="campos.p_icms_mva_p.class" class="dem-edi-pro-tab-item-editar--p_icms_mva_p"
                :cpntStatus='campos.p_icms_mva_p.status'
                :cpntId='campos.p_icms_mva_p.id'
                :cpntAlerta='campos.p_icms_mva_p.alerta'
                :cpntClassDivField='campos.p_icms_mva_p.classDivField'
                :cpntNome='campos.p_icms_mva_p.nome'
                :cpntValue='campos.p_icms_mva_p.value'
                :cpntAutoComplete='campos.p_icms_mva_p.autocomplete'
                :cpntMask='campos.p_icms_mva_p.mask'
                :cpntOptionInicialNome='campos.p_icms_mva_p.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_mva_p.optionInicialValue'
                :cpntDisabled='campos.p_icms_mva_p.disabled()'
                :cpntMostrar='campos.p_icms_mva_p.mostrar'
                :cpntExplica='campos.p_icms_mva_p.explica'
                :cpntAutoFocus='campos.p_icms_mva_p.autofocus'
                :cpntMensagem='campos.p_icms_mva_p.mensagem'
                :cpntMensagemTipo='campos.p_icms_mva_p.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_mva_p.placeholder'
                :cpntPosicionar='campos.p_icms_mva_p.posicionar'
                :cpntOnChange='campos.p_icms_mva_p.onChange'
                :cpntOnBlur='campos.p_icms_mva_p.onBlur'
                ref='p_icms_mva_p'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_st_bc_v">
              <App-Input :data-time="time" :class="campos.p_icms_st_bc_v.class" class="dem-edi-pro-tab-item-editar--p_icms_st_bc_v"
                :cpntStatus='campos.p_icms_st_bc_v.status'
                :cpntId='campos.p_icms_st_bc_v.id'
                :cpntAlerta='campos.p_icms_st_bc_v.alerta'
                :cpntClassDivField='campos.p_icms_st_bc_v.classDivField'
                :cpntNome='campos.p_icms_st_bc_v.nome'
                :cpntValue='campos.p_icms_st_bc_v.value'
                :cpntAutoComplete='campos.p_icms_st_bc_v.autocomplete'
                :cpntMask='campos.p_icms_st_bc_v.mask'
                :cpntOptionInicialNome='campos.p_icms_st_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_st_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_st_bc_v.disabled()'
                :cpntMostrar='campos.p_icms_st_bc_v.mostrar'
                :cpntExplica='campos.p_icms_st_bc_v.explica'
                :cpntAutoFocus='campos.p_icms_st_bc_v.autofocus'
                :cpntMensagem='campos.p_icms_st_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_st_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_st_bc_v.placeholder'
                :cpntPosicionar='campos.p_icms_st_bc_v.posicionar'
                :cpntOnChange='campos.p_icms_st_bc_v.onChange'
                :cpntOnBlur='campos.p_icms_st_bc_v.onBlur'
                ref='p_icms_st_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_st_a">
              <App-Input :data-time="time" :class="campos.p_icms_st_a.class" class="dem-edi-pro-tab-item-editar--p_icms_st_a"
                :cpntStatus='campos.p_icms_st_a.status'
                :cpntId='campos.p_icms_st_a.id'
                :cpntAlerta='campos.p_icms_st_a.alerta'
                :cpntClassDivField='campos.p_icms_st_a.classDivField'
                :cpntNome='campos.p_icms_st_a.nome'
                :cpntValue='campos.p_icms_st_a.value'
                :cpntAutoComplete='campos.p_icms_st_a.autocomplete'
                :cpntMask='campos.p_icms_st_a.mask'
                :cpntOptionInicialNome='campos.p_icms_st_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_st_a.optionInicialValue'
                :cpntDisabled='campos.p_icms_st_a.disabled()'
                :cpntMostrar='campos.p_icms_st_a.mostrar'
                :cpntExplica='campos.p_icms_st_a.explica'
                :cpntAutoFocus='campos.p_icms_st_a.autofocus'
                :cpntMensagem='campos.p_icms_st_a.mensagem'
                :cpntMensagemTipo='campos.p_icms_st_a.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_st_a.placeholder'
                :cpntPosicionar='campos.p_icms_st_a.posicionar'
                :cpntOnChange='campos.p_icms_st_a.onChange'
                :cpntOnBlur='campos.p_icms_st_a.onBlur'
                ref='p_icms_st_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_bc_st_p_r">
              <App-Input :data-time="time" :class="campos.p_icms_bc_st_p_r.class" class="dem-edi-pro-tab-item-editar--p_icms_bc_st_p_r"
                :cpntStatus='campos.p_icms_bc_st_p_r.status'
                :cpntId='campos.p_icms_bc_st_p_r.id'
                :cpntAlerta='campos.p_icms_bc_st_p_r.alerta'
                :cpntClassDivField='campos.p_icms_bc_st_p_r.classDivField'
                :cpntNome='campos.p_icms_bc_st_p_r.nome'
                :cpntValue='campos.p_icms_bc_st_p_r.value'
                :cpntAutoComplete='campos.p_icms_bc_st_p_r.autocomplete'
                :cpntMask='campos.p_icms_bc_st_p_r.mask'
                :cpntOptionInicialNome='campos.p_icms_bc_st_p_r.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_bc_st_p_r.optionInicialValue'
                :cpntDisabled='campos.p_icms_bc_st_p_r.disabled()'
                :cpntMostrar='campos.p_icms_bc_st_p_r.mostrar'
                :cpntExplica='campos.p_icms_bc_st_p_r.explica'
                :cpntAutoFocus='campos.p_icms_bc_st_p_r.autofocus'
                :cpntMensagem='campos.p_icms_bc_st_p_r.mensagem'
                :cpntMensagemTipo='campos.p_icms_bc_st_p_r.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_bc_st_p_r.placeholder'
                :cpntPosicionar='campos.p_icms_bc_st_p_r.posicionar'
                :cpntOnChange='campos.p_icms_bc_st_p_r.onChange'
                :cpntOnBlur='campos.p_icms_bc_st_p_r.onBlur'
                ref='p_icms_bc_st_p_r'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_st_v">
              <App-Input :data-time="time" :class="campos.p_icms_st_v.class" class="dem-edi-pro-tab-item-editar--p_icms_st_v"
                :cpntStatus='campos.p_icms_st_v.status'
                :cpntId='campos.p_icms_st_v.id'
                :cpntAlerta='campos.p_icms_st_v.alerta'
                :cpntClassDivField='campos.p_icms_st_v.classDivField'
                :cpntNome='campos.p_icms_st_v.nome'
                :cpntValue='campos.p_icms_st_v.value'
                :cpntAutoComplete='campos.p_icms_st_v.autocomplete'
                :cpntMask='campos.p_icms_st_v.mask'
                :cpntOptionInicialNome='campos.p_icms_st_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_st_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_st_v.disabled()'
                :cpntMostrar='campos.p_icms_st_v.mostrar'
                :cpntExplica='campos.p_icms_st_v.explica'
                :cpntAutoFocus='campos.p_icms_st_v.autofocus'
                :cpntMensagem='campos.p_icms_st_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_st_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_st_v.placeholder'
                :cpntPosicionar='campos.p_icms_st_v.posicionar'
                :cpntOnChange='campos.p_icms_st_v.onChange'
                :cpntOnBlur='campos.p_icms_st_v.onBlur'
                ref='p_icms_st_v'
              ></App-Input>
            </div>
          </div>
        </div>

        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          FCP
        </div>
        <div class="quadrado">
          <div>
            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_bc_v">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_bc_v.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_bc_v" 
                :cpntStatus='campos.p_icms_fcp_bc_v.status'
                :cpntId='campos.p_icms_fcp_bc_v.id'
                :cpntAlerta='campos.p_icms_fcp_bc_v.alerta'
                :cpntClassDivField='campos.p_icms_fcp_bc_v.classDivField'
                :cpntNome='campos.p_icms_fcp_bc_v.nome'
                :cpntValue='campos.p_icms_fcp_bc_v.value'
                :cpntAutoComplete='campos.p_icms_fcp_bc_v.autocomplete'
                :cpntMask='campos.p_icms_fcp_bc_v.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_bc_v.disabled()'
                :cpntMostrar='campos.p_icms_fcp_bc_v.mostrar'
                :cpntExplica='campos.p_icms_fcp_bc_v.explica'
                :cpntAutoFocus='campos.p_icms_fcp_bc_v.autofocus'
                :cpntMensagem='campos.p_icms_fcp_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_bc_v.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_bc_v.posicionar'
                :cpntOnChange='campos.p_icms_fcp_bc_v.onChange'
                :cpntOnBlur='campos.p_icms_fcp_bc_v.onBlur'
                ref='p_icms_fcp_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_a">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_a.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_a" 
                :cpntStatus='campos.p_icms_fcp_a.status'
                :cpntId='campos.p_icms_fcp_a.id'
                :cpntAlerta='campos.p_icms_fcp_a.alerta'
                :cpntClassDivField='campos.p_icms_fcp_a.classDivField'
                :cpntNome='campos.p_icms_fcp_a.nome'
                :cpntValue='campos.p_icms_fcp_a.value'
                :cpntAutoComplete='campos.p_icms_fcp_a.autocomplete'
                :cpntMask='campos.p_icms_fcp_a.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_a.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_a.disabled()'
                :cpntMostrar='campos.p_icms_fcp_a.mostrar'
                :cpntExplica='campos.p_icms_fcp_a.explica'
                :cpntAutoFocus='campos.p_icms_fcp_a.autofocus'
                :cpntMensagem='campos.p_icms_fcp_a.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_a.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_a.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_a.posicionar'
                :cpntOnChange='campos.p_icms_fcp_a.onChange'
                :cpntOnBlur='campos.p_icms_fcp_a.onBlur'
                ref='p_icms_fcp_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_v">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_v.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_v"
                :cpntStatus='campos.p_icms_fcp_v.status'
                :cpntId='campos.p_icms_fcp_v.id'
                :cpntAlerta='campos.p_icms_fcp_v.alerta'
                :cpntClassDivField='campos.p_icms_fcp_v.classDivField'
                :cpntNome='campos.p_icms_fcp_v.nome'
                :cpntValue='campos.p_icms_fcp_v.value'
                :cpntAutoComplete='campos.p_icms_fcp_v.autocomplete'
                :cpntMask='campos.p_icms_fcp_v.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_v.disabled()'
                :cpntMostrar='campos.p_icms_fcp_v.mostrar'
                :cpntExplica='campos.p_icms_fcp_v.explica'
                :cpntAutoFocus='campos.p_icms_fcp_v.autofocus'
                :cpntMensagem='campos.p_icms_fcp_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_v.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_v.posicionar'
                :cpntOnChange='campos.p_icms_fcp_v.onChange'
                :cpntOnBlur='campos.p_icms_fcp_v.onBlur'
                ref='p_icms_fcp_v'
              ></App-Input>
            </div>
          </div>

          <div>
            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_bc_v">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_bc_v.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_bc_v" 
                :cpntStatus='campos.p_icms_fcp_st_bc_v.status'
                :cpntId='campos.p_icms_fcp_st_bc_v.id'
                :cpntAlerta='campos.p_icms_fcp_st_bc_v.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_bc_v.classDivField'
                :cpntNome='campos.p_icms_fcp_st_bc_v.nome'
                :cpntValue='campos.p_icms_fcp_st_bc_v.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_bc_v.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_bc_v.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_bc_v.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_bc_v.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_bc_v.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_bc_v.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_bc_v.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_bc_v.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_bc_v.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_bc_v.onBlur'
                ref='p_icms_fcp_st_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_a">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_a.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_a" 
                :cpntStatus='campos.p_icms_fcp_st_a.status'
                :cpntId='campos.p_icms_fcp_st_a.id'
                :cpntAlerta='campos.p_icms_fcp_st_a.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_a.classDivField'
                :cpntNome='campos.p_icms_fcp_st_a.nome'
                :cpntValue='campos.p_icms_fcp_st_a.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_a.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_a.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_a.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_a.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_a.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_a.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_a.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_a.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_a.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_a.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_a.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_a.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_a.onBlur'
                ref='p_icms_fcp_st_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_v">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_v.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_v"
                :cpntStatus='campos.p_icms_fcp_st_v.status'
                :cpntId='campos.p_icms_fcp_st_v.id'
                :cpntAlerta='campos.p_icms_fcp_st_v.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_v.classDivField'
                :cpntNome='campos.p_icms_fcp_st_v.nome'
                :cpntValue='campos.p_icms_fcp_st_v.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_v.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_v.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_v.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_v.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_v.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_v.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_v.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_v.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_v.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_v.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_v.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_v.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_v.onBlur'
                ref='p_icms_fcp_st_v'
              ></App-Input>
            </div>
          </div>

          <div>
            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_a_cf">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_a_cf.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_a_cf" 
                :cpntStatus='campos.p_icms_fcp_st_a_cf.status'
                :cpntId='campos.p_icms_fcp_st_a_cf.id'
                :cpntAlerta='campos.p_icms_fcp_st_a_cf.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_a_cf.classDivField'
                :cpntNome='campos.p_icms_fcp_st_a_cf.nome'
                :cpntValue='campos.p_icms_fcp_st_a_cf.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_a_cf.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_a_cf.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_a_cf.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_a_cf.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_a_cf.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_a_cf.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_a_cf.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_a_cf.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_a_cf.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_a_cf.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_a_cf.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_a_cf.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_a_cf.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_a_cf.onBlur'
                ref='p_icms_fcp_st_a_cf'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_bc">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_r_bc.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_bc" 
                :cpntStatus='campos.p_icms_fcp_st_r_bc.status'
                :cpntId='campos.p_icms_fcp_st_r_bc.id'
                :cpntAlerta='campos.p_icms_fcp_st_r_bc.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_r_bc.classDivField'
                :cpntNome='campos.p_icms_fcp_st_r_bc.nome'
                :cpntValue='campos.p_icms_fcp_st_r_bc.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_r_bc.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_r_bc.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_r_bc.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_r_bc.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_r_bc.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_r_bc.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_r_bc.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_r_bc.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_r_bc.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_r_bc.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_r_bc.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_r_bc.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_r_bc.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_r_bc.onBlur'
                ref='p_icms_fcp_st_r_bc'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_a">
              <App-Input :data-time="time" :class="campos.p_icms_fcp_st_r_a.class" class="dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_a"
                :cpntStatus='campos.p_icms_fcp_st_r_a.status'
                :cpntId='campos.p_icms_fcp_st_r_a.id'
                :cpntAlerta='campos.p_icms_fcp_st_r_a.alerta'
                :cpntClassDivField='campos.p_icms_fcp_st_r_a.classDivField'
                :cpntNome='campos.p_icms_fcp_st_r_a.nome'
                :cpntValue='campos.p_icms_fcp_st_r_a.value'
                :cpntAutoComplete='campos.p_icms_fcp_st_r_a.autocomplete'
                :cpntMask='campos.p_icms_fcp_st_r_a.mask'
                :cpntOptionInicialNome='campos.p_icms_fcp_st_r_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_icms_fcp_st_r_a.optionInicialValue'
                :cpntDisabled='campos.p_icms_fcp_st_r_a.disabled()'
                :cpntMostrar='campos.p_icms_fcp_st_r_a.mostrar'
                :cpntExplica='campos.p_icms_fcp_st_r_a.explica'
                :cpntAutoFocus='campos.p_icms_fcp_st_r_a.autofocus'
                :cpntMensagem='campos.p_icms_fcp_st_r_a.mensagem'
                :cpntMensagemTipo='campos.p_icms_fcp_st_r_a.mensagemTipo'
                :cpntPlaceholder='campos.p_icms_fcp_st_r_a.placeholder'
                :cpntPosicionar='campos.p_icms_fcp_st_r_a.posicionar'
                :cpntOnChange='campos.p_icms_fcp_st_r_a.onChange'
                :cpntOnBlur='campos.p_icms_fcp_st_r_a.onBlur'
                ref='p_icms_fcp_st_r_a'
              ></App-Input>
            </div>
          </div>
        </div>

        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          PIS
        </div>
        <div class="quadrado">
          <div>
            <div class="dem-edi-pro-tab-item-editar--p_pis_cst">
              <App-Select :data-time="time" :class="campos.p_pis_cst.class" class="dem-edi-pro-tab-item-editar--p_pis_cst" 
                :cpntStatus='campos.p_pis_cst.status'
                :cpntId='campos.p_pis_cst.id'
                :cpntAlerta='campos.p_pis_cst.alerta'
                :cpntTabIndex='campos.p_pis_cst.tabIndex'
                :cpntNome='campos.p_pis_cst.nome'
                :cpntValue='campos.p_pis_cst.value'
                :cpntMensagem='campos.p_pis_cst.mensagem'
                :cpntMensagemTipo='campos.p_pis_cst.mensagemTipo'
                :cpntDisabled='campos.p_pis_cst.disabled()'
                :cpntMostrar='campos.p_pis_cst.mostrar'
                :cpntExplica='campos.p_pis_cst.explica'
                :cpntPlaceholder='campos.p_pis_cst.placeholder'
                :cpntValueRef='campos.p_pis_cst.valueRef'
                :cpntRouter='campos.p_pis_cst.router'
                :cpntField='campos.p_pis_cst.field'
                :cpntWhere='campos.p_pis_cst.where'
                :cpntAddButForm='campos.p_pis_cst.addButForm'
                :cpntKeyMostra='campos.p_pis_cst.keyMostra'
                :cpntTipoOrder='campos.p_pis_cst.tipoOrder'
                :cpntOrder='campos.p_pis_cst.order'
                :cpntOptions='campos.p_pis_cst.options'
                :cpntOptionInicialNome='campos.p_pis_cst.optionInicialNome'
                :cpntOptionInicialValue='campos.p_pis_cst.optionInicialValue'
                :cpntKeyValue='campos.p_pis_cst.keyValue'
                :cpntSearchMinimo='campos.p_pis_cst.searchMinimo'
                :cpntMask='campos.p_pis_cst.mask'

                :cpntOnBuscarOptions='campos.p_pis_cst.onBuscarOptions'
                :cpntOnChange='campos.p_pis_cst.onChange'
                :cpntOnBlur='campos.p_pis_cst.onBlur'
                :cpntOnRealizaBusca='campos.p_pis_cst.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_pis_cst.onKeyPressEnter'
                ref="p_pis_cst"
              ></App-Select>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_pis_bc_v">
              <App-Input :data-time="time" :class="campos.p_pis_bc_v.class" class="dem-edi-pro-tab-item-editar--p_pis_bc_v" 
                :cpntStatus='campos.p_pis_bc_v.status'
                :cpntId='campos.p_pis_bc_v.id'
                :cpntAlerta='campos.p_pis_bc_v.alerta'
                :cpntClassDivField='campos.p_pis_bc_v.classDivField'
                :cpntNome='campos.p_pis_bc_v.nome'
                :cpntValue='campos.p_pis_bc_v.value'
                :cpntAutoComplete='campos.p_pis_bc_v.autocomplete'
                :cpntMask='campos.p_pis_bc_v.mask'
                :cpntOptionInicialNome='campos.p_pis_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_pis_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_pis_bc_v.disabled()'
                :cpntMostrar='campos.p_pis_bc_v.mostrar'
                :cpntExplica='campos.p_pis_bc_v.explica'
                :cpntAutoFocus='campos.p_pis_bc_v.autofocus'
                :cpntMensagem='campos.p_pis_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_pis_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_pis_bc_v.placeholder'
                :cpntPosicionar='campos.p_pis_bc_v.posicionar'
                :cpntOnChange='campos.p_pis_bc_v.onChange'
                :cpntOnBlur='campos.p_pis_bc_v.onBlur'
                ref='p_pis_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_pis_a">
              <App-Input :data-time="time" :class="campos.p_pis_a.class" class="dem-edi-pro-tab-item-editar--p_pis_a" 
                :cpntStatus='campos.p_pis_a.status'
                :cpntId='campos.p_pis_a.id'
                :cpntAlerta='campos.p_pis_a.alerta'
                :cpntClassDivField='campos.p_pis_a.classDivField'
                :cpntNome='campos.p_pis_a.nome'
                :cpntValue='campos.p_pis_a.value'
                :cpntAutoComplete='campos.p_pis_a.autocomplete'
                :cpntMask='campos.p_pis_a.mask'
                :cpntOptionInicialNome='campos.p_pis_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_pis_a.optionInicialValue'
                :cpntDisabled='campos.p_pis_a.disabled()'
                :cpntMostrar='campos.p_pis_a.mostrar'
                :cpntExplica='campos.p_pis_a.explica'
                :cpntAutoFocus='campos.p_pis_a.autofocus'
                :cpntMensagem='campos.p_pis_a.mensagem'
                :cpntMensagemTipo='campos.p_pis_a.mensagemTipo'
                :cpntPlaceholder='campos.p_pis_a.placeholder'
                :cpntPosicionar='campos.p_pis_a.posicionar'
                :cpntOnChange='campos.p_pis_a.onChange'
                :cpntOnBlur='campos.p_pis_a.onBlur'
                ref='p_pis_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_pis_v">
              <App-Input :data-time="time" :class="campos.p_pis_v.class" class="dem-edi-pro-tab-item-editar--p_pis_v"
                :cpntStatus='campos.p_pis_v.status'
                :cpntId='campos.p_pis_v.id'
                :cpntAlerta='campos.p_pis_v.alerta'
                :cpntClassDivField='campos.p_pis_v.classDivField'
                :cpntNome='campos.p_pis_v.nome'
                :cpntValue='campos.p_pis_v.value'
                :cpntAutoComplete='campos.p_pis_v.autocomplete'
                :cpntMask='campos.p_pis_v.mask'
                :cpntOptionInicialNome='campos.p_pis_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_pis_v.optionInicialValue'
                :cpntDisabled='campos.p_pis_v.disabled()'
                :cpntMostrar='campos.p_pis_v.mostrar'
                :cpntExplica='campos.p_pis_v.explica'
                :cpntAutoFocus='campos.p_pis_v.autofocus'
                :cpntMensagem='campos.p_pis_v.mensagem'
                :cpntMensagemTipo='campos.p_pis_v.mensagemTipo'
                :cpntPlaceholder='campos.p_pis_v.placeholder'
                :cpntPosicionar='campos.p_pis_v.posicionar'
                :cpntOnChange='campos.p_pis_v.onChange'
                :cpntOnBlur='campos.p_pis_v.onBlur'
                ref='p_pis_v'
              ></App-Input>
            </div>
          </div>
        </div>

        <div class="titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          COFINS
        </div>
        <div class="quadrado">
          <div>
            <div class="dem-edi-pro-tab-item-editar--p_cofins_cst">
              <App-Select :data-time="time" :class="campos.p_cofins_cst.class" class="dem-edi-pro-tab-item-editar--p_cofins_cst" 
                :cpntStatus='campos.p_cofins_cst.status'
                :cpntId='campos.p_cofins_cst.id'
                :cpntAlerta='campos.p_cofins_cst.alerta'
                :cpntTabIndex='campos.p_cofins_cst.tabIndex'
                :cpntNome='campos.p_cofins_cst.nome'
                :cpntValue='campos.p_cofins_cst.value'
                :cpntMensagem='campos.p_cofins_cst.mensagem'
                :cpntMensagemTipo='campos.p_cofins_cst.mensagemTipo'
                :cpntDisabled='campos.p_cofins_cst.disabled()'
                :cpntMostrar='campos.p_cofins_cst.mostrar'
                :cpntExplica='campos.p_cofins_cst.explica'
                :cpntPlaceholder='campos.p_cofins_cst.placeholder'
                :cpntValueRef='campos.p_cofins_cst.valueRef'
                :cpntRouter='campos.p_cofins_cst.router'
                :cpntField='campos.p_cofins_cst.field'
                :cpntWhere='campos.p_cofins_cst.where'
                :cpntAddButForm='campos.p_cofins_cst.addButForm'
                :cpntKeyMostra='campos.p_cofins_cst.keyMostra'
                :cpntTipoOrder='campos.p_cofins_cst.tipoOrder'
                :cpntOrder='campos.p_cofins_cst.order'
                :cpntOptions='campos.p_cofins_cst.options'
                :cpntOptionInicialNome='campos.p_cofins_cst.optionInicialNome'
                :cpntOptionInicialValue='campos.p_cofins_cst.optionInicialValue'
                :cpntKeyValue='campos.p_cofins_cst.keyValue'
                :cpntSearchMinimo='campos.p_cofins_cst.searchMinimo'
                :cpntMask='campos.p_cofins_cst.mask'

                :cpntOnBuscarOptions='campos.p_cofins_cst.onBuscarOptions'
                :cpntOnChange='campos.p_cofins_cst.onChange'
                :cpntOnBlur='campos.p_cofins_cst.onBlur'
                :cpntOnRealizaBusca='campos.p_cofins_cst.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_cofins_cst.onKeyPressEnter'
                ref="p_cofins_cst"
              ></App-Select>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_cofins_bc_v">
              <App-Input :data-time="time" :class="campos.p_cofins_bc_v.class" class="dem-edi-pro-tab-item-editar--p_cofins_bc_v" 
                :cpntStatus='campos.p_cofins_bc_v.status'
                :cpntId='campos.p_cofins_bc_v.id'
                :cpntAlerta='campos.p_cofins_bc_v.alerta'
                :cpntClassDivField='campos.p_cofins_bc_v.classDivField'
                :cpntNome='campos.p_cofins_bc_v.nome'
                :cpntValue='campos.p_cofins_bc_v.value'
                :cpntAutoComplete='campos.p_cofins_bc_v.autocomplete'
                :cpntMask='campos.p_cofins_bc_v.mask'
                :cpntOptionInicialNome='campos.p_cofins_bc_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_cofins_bc_v.optionInicialValue'
                :cpntDisabled='campos.p_cofins_bc_v.disabled()'
                :cpntMostrar='campos.p_cofins_bc_v.mostrar'
                :cpntExplica='campos.p_cofins_bc_v.explica'
                :cpntAutoFocus='campos.p_cofins_bc_v.autofocus'
                :cpntMensagem='campos.p_cofins_bc_v.mensagem'
                :cpntMensagemTipo='campos.p_cofins_bc_v.mensagemTipo'
                :cpntPlaceholder='campos.p_cofins_bc_v.placeholder'
                :cpntPosicionar='campos.p_cofins_bc_v.posicionar'
                :cpntOnChange='campos.p_cofins_bc_v.onChange'
                :cpntOnBlur='campos.p_cofins_bc_v.onBlur'
                ref='p_cofins_bc_v'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_cofins_a">
              <App-Input :data-time="time" :class="campos.p_cofins_a.class" class="dem-edi-pro-tab-item-editar--p_cofins_a" 
                :cpntStatus='campos.p_cofins_a.status'
                :cpntId='campos.p_cofins_a.id'
                :cpntAlerta='campos.p_cofins_a.alerta'
                :cpntClassDivField='campos.p_cofins_a.classDivField'
                :cpntNome='campos.p_cofins_a.nome'
                :cpntValue='campos.p_cofins_a.value'
                :cpntAutoComplete='campos.p_cofins_a.autocomplete'
                :cpntMask='campos.p_cofins_a.mask'
                :cpntOptionInicialNome='campos.p_cofins_a.optionInicialNome'
                :cpntOptionInicialValue='campos.p_cofins_a.optionInicialValue'
                :cpntDisabled='campos.p_cofins_a.disabled()'
                :cpntMostrar='campos.p_cofins_a.mostrar'
                :cpntExplica='campos.p_cofins_a.explica'
                :cpntAutoFocus='campos.p_cofins_a.autofocus'
                :cpntMensagem='campos.p_cofins_a.mensagem'
                :cpntMensagemTipo='campos.p_cofins_a.mensagemTipo'
                :cpntPlaceholder='campos.p_cofins_a.placeholder'
                :cpntPosicionar='campos.p_cofins_a.posicionar'
                :cpntOnChange='campos.p_cofins_a.onChange'
                :cpntOnBlur='campos.p_cofins_a.onBlur'
                ref='p_cofins_a'
              ></App-Input>
            </div>

            <div class="dem-edi-pro-tab-item-editar--p_cofins_v">
              <App-Input :data-time="time" :class="campos.p_cofins_v.class" class="dem-edi-pro-tab-item-editar--p_cofins_v"
                :cpntStatus='campos.p_cofins_v.status'
                :cpntId='campos.p_cofins_v.id'
                :cpntAlerta='campos.p_cofins_v.alerta'
                :cpntClassDivField='campos.p_cofins_v.classDivField'
                :cpntNome='campos.p_cofins_v.nome'
                :cpntValue='campos.p_cofins_v.value'
                :cpntAutoComplete='campos.p_cofins_v.autocomplete'
                :cpntMask='campos.p_cofins_v.mask'
                :cpntOptionInicialNome='campos.p_cofins_v.optionInicialNome'
                :cpntOptionInicialValue='campos.p_cofins_v.optionInicialValue'
                :cpntDisabled='campos.p_cofins_v.disabled()'
                :cpntMostrar='campos.p_cofins_v.mostrar'
                :cpntExplica='campos.p_cofins_v.explica'
                :cpntAutoFocus='campos.p_cofins_v.autofocus'
                :cpntMensagem='campos.p_cofins_v.mensagem'
                :cpntMensagemTipo='campos.p_cofins_v.mensagemTipo'
                :cpntPlaceholder='campos.p_cofins_v.placeholder'
                :cpntPosicionar='campos.p_cofins_v.posicionar'
                :cpntOnChange='campos.p_cofins_v.onChange'
                :cpntOnBlur='campos.p_cofins_v.onBlur'
                ref='p_cofins_v'
              ></App-Input>
            </div>
          </div>
        </div>

        
        <template v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && dados.demanda_p_doc_fin === '4'">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            IPI Devolução
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_ipi_devol_p">
                <App-Input :data-time="time" :class="campos.p_ipi_devol_p.class" class="dem-edi-pro-tab-item-editar--p_ipi_devol_p"
                  :cpntStatus='campos.p_ipi_devol_p.status'
                  :cpntId='campos.p_ipi_devol_p.id'
                  :cpntAlerta='campos.p_ipi_devol_p.alerta'
                  :cpntClassDivField='campos.p_ipi_devol_p.classDivField'
                  :cpntNome='campos.p_ipi_devol_p.nome'
                  :cpntValue='campos.p_ipi_devol_p.value'
                  :cpntAutoComplete='campos.p_ipi_devol_p.autocomplete'
                  :cpntMask='campos.p_ipi_devol_p.mask'
                  :cpntOptionInicialNome='campos.p_ipi_devol_p.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_devol_p.optionInicialValue'
                  :cpntDisabled='campos.p_ipi_devol_p.disabled()'
                  :cpntMostrar='campos.p_ipi_devol_p.mostrar'
                  :cpntExplica='campos.p_ipi_devol_p.explica'
                  :cpntAutoFocus='campos.p_ipi_devol_p.autofocus'
                  :cpntMensagem='campos.p_ipi_devol_p.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_devol_p.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_devol_p.placeholder'
                  :cpntPosicionar='campos.p_ipi_devol_p.posicionar'
                  :cpntOnChange='campos.p_ipi_devol_p.onChange'
                  :cpntOnBlur='campos.p_ipi_devol_p.onBlur'
                  ref='p_ipi_devol_p'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_devol_v">
                <App-Input :data-time="time" :class="campos.p_ipi_devol_v.class" class="dem-edi-pro-tab-item-editar--p_ipi_devol_v"
                  :cpntStatus='campos.p_ipi_devol_v.status'
                  :cpntId='campos.p_ipi_devol_v.id'
                  :cpntAlerta='campos.p_ipi_devol_v.alerta'
                  :cpntClassDivField='campos.p_ipi_devol_v.classDivField'
                  :cpntNome='campos.p_ipi_devol_v.nome'
                  :cpntValue='campos.p_ipi_devol_v.value'
                  :cpntAutoComplete='campos.p_ipi_devol_v.autocomplete'
                  :cpntMask='campos.p_ipi_devol_v.mask'
                  :cpntOptionInicialNome='campos.p_ipi_devol_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_devol_v.optionInicialValue'
                  :cpntDisabled='campos.p_ipi_devol_v.disabled()'
                  :cpntMostrar='campos.p_ipi_devol_v.mostrar'
                  :cpntExplica='campos.p_ipi_devol_v.explica'
                  :cpntAutoFocus='campos.p_ipi_devol_v.autofocus'
                  :cpntMensagem='campos.p_ipi_devol_v.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_devol_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_devol_v.placeholder'
                  :cpntPosicionar='campos.p_ipi_devol_v.posicionar'
                  :cpntOnChange='campos.p_ipi_devol_v.onChange'
                  :cpntOnBlur='campos.p_ipi_devol_v.onBlur'
                  ref='p_ipi_devol_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            IPI
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_ipi_cst">
                <App-Select :data-time="time" :class="campos.p_ipi_cst.class" class="dem-edi-pro-tab-item-editar--p_ipi_cst"
                  :cpntStatus='campos.p_ipi_cst.status'
                  :cpntId='campos.p_ipi_cst.id'
                  :cpntAlerta='campos.p_ipi_cst.alerta'
                  :cpntTabIndex='campos.p_ipi_cst.tabIndex'
                  :cpntNome='campos.p_ipi_cst.nome'
                  :cpntValue='campos.p_ipi_cst.value'
                  :cpntMensagem='campos.p_ipi_cst.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_cst.mensagemTipo'
                  :cpntDisabled='campos.p_ipi_cst.disabled()'
                  :cpntMostrar='campos.p_ipi_cst.mostrar'
                  :cpntExplica='campos.p_ipi_cst.explica'
                  :cpntPlaceholder='campos.p_ipi_cst.placeholder'
                  :cpntValueRef='campos.p_ipi_cst.valueRef'
                  :cpntRouter='campos.p_ipi_cst.router'
                  :cpntField='campos.p_ipi_cst.field'
                  :cpntWhere='campos.p_ipi_cst.where'
                  :cpntAddButForm='campos.p_ipi_cst.addButForm'
                  :cpntKeyMostra='campos.p_ipi_cst.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_cst.tipoOrder'
                  :cpntOrder='campos.p_ipi_cst.order'
                  :cpntOptions='campos.p_ipi_cst.options'
                  :cpntOptionInicialNome='campos.p_ipi_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_cst.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_cst.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_cst.searchMinimo'
                  :cpntMask='campos.p_ipi_cst.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_cst.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_cst.onChange'
                  :cpntOnBlur='campos.p_ipi_cst.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_cst.onKeyPressEnter'
                  ref="p_ipi_cst"
                ></App-Select>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_bc_v">
                <App-Input :data-time="time" :class="campos.p_ipi_bc_v.class" class="dem-edi-pro-tab-item-editar--p_ipi_bc_v"
                  :cpntStatus='campos.p_ipi_bc_v.status'
                  :cpntId='campos.p_ipi_bc_v.id'
                  :cpntAlerta='campos.p_ipi_bc_v.alerta'
                  :cpntClassDivField='campos.p_ipi_bc_v.classDivField'
                  :cpntNome='campos.p_ipi_bc_v.nome'
                  :cpntValue='campos.p_ipi_bc_v.value'
                  :cpntAutoComplete='campos.p_ipi_bc_v.autocomplete'
                  :cpntMask='campos.p_ipi_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_ipi_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_bc_v.optionInicialValue'
                  :cpntDisabled='campos.p_ipi_bc_v.disabled()'
                  :cpntMostrar='campos.p_ipi_bc_v.mostrar'
                  :cpntExplica='campos.p_ipi_bc_v.explica'
                  :cpntAutoFocus='campos.p_ipi_bc_v.autofocus'
                  :cpntMensagem='campos.p_ipi_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_bc_v.placeholder'
                  :cpntPosicionar='campos.p_ipi_bc_v.posicionar'
                  :cpntOnChange='campos.p_ipi_bc_v.onChange'
                  :cpntOnBlur='campos.p_ipi_bc_v.onBlur'
                  ref='p_ipi_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_a">
                <App-Input :data-time="time" :class="campos.p_ipi_a.class" class="dem-edi-pro-tab-item-editar--p_ipi_a"
                  :cpntStatus='campos.p_ipi_a.status'
                  :cpntId='campos.p_ipi_a.id'
                  :cpntAlerta='campos.p_ipi_a.alerta'
                  :cpntClassDivField='campos.p_ipi_a.classDivField'
                  :cpntNome='campos.p_ipi_a.nome'
                  :cpntValue='campos.p_ipi_a.value'
                  :cpntAutoComplete='campos.p_ipi_a.autocomplete'
                  :cpntMask='campos.p_ipi_a.mask'
                  :cpntOptionInicialNome='campos.p_ipi_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_a.optionInicialValue'
                  :cpntDisabled='campos.p_ipi_a.disabled()'
                  :cpntMostrar='campos.p_ipi_a.mostrar'
                  :cpntExplica='campos.p_ipi_a.explica'
                  :cpntAutoFocus='campos.p_ipi_a.autofocus'
                  :cpntMensagem='campos.p_ipi_a.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_a.placeholder'
                  :cpntPosicionar='campos.p_ipi_a.posicionar'
                  :cpntOnChange='campos.p_ipi_a.onChange'
                  :cpntOnBlur='campos.p_ipi_a.onBlur'
                  ref='p_ipi_a'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_v">
                <App-Input :data-time="time" :class="campos.p_ipi_v.class" class="dem-edi-pro-tab-item-editar--p_ipi_v"
                  :cpntStatus='campos.p_ipi_v.status'
                  :cpntId='campos.p_ipi_v.id'
                  :cpntAlerta='campos.p_ipi_v.alerta'
                  :cpntClassDivField='campos.p_ipi_v.classDivField'
                  :cpntNome='campos.p_ipi_v.nome'
                  :cpntValue='campos.p_ipi_v.value'
                  :cpntAutoComplete='campos.p_ipi_v.autocomplete'
                  :cpntMask='campos.p_ipi_v.mask'
                  :cpntOptionInicialNome='campos.p_ipi_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_v.optionInicialValue'
                  :cpntDisabled='campos.p_ipi_v.disabled()'
                  :cpntMostrar='campos.p_ipi_v.mostrar'
                  :cpntAutoFocus='campos.p_ipi_v.autofocus'
                  :cpntMensagem='campos.p_ipi_v.mensagem'
                  :cpntExplica='campos.p_ipi_v.explica'
                  :cpntMensagemTipo='campos.p_ipi_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_v.placeholder'
                  :cpntPosicionar='campos.p_ipi_v.posicionar'
                  :cpntOnChange='campos.p_ipi_v.onChange'
                  :cpntOnBlur='campos.p_ipi_v.onBlur'
                  ref='p_ipi_v'
                ></App-Input>
              </div>
            </div>

            <div>
              <div class="dem-edi-pro-tab-item-editar--p_ipi_enq">
                <App-Select :data-time="time" :class="campos.p_ipi_enq.class" class="dem-edi-pro-tab-item-editar--p_ipi_enq"
                  :cpntStatus='campos.p_ipi_enq.status'
                  :cpntId='campos.p_ipi_enq.id'
                  :cpntAlerta='campos.p_ipi_enq.alerta'
                  :cpntTabIndex='campos.p_ipi_enq.tabIndex'
                  :cpntNome='campos.p_ipi_enq.nome'
                  :cpntValue='campos.p_ipi_enq.value'
                  :cpntMensagem='campos.p_ipi_enq.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_enq.mensagemTipo'
                  :cpntDisabled='campos.p_ipi_enq.disabled()'
                  :cpntMostrar='campos.p_ipi_enq.mostrar'
                  :cpntExplica='campos.p_ipi_enq.explica'
                  :cpntPlaceholder='campos.p_ipi_enq.placeholder'
                  :cpntValueRef='campos.p_ipi_enq.valueRef'
                  :cpntRouter='campos.p_ipi_enq.router'
                  :cpntField='campos.p_ipi_enq.field'
                  :cpntWhere='campos.p_ipi_enq.where'
                  :cpntAddButForm='campos.p_ipi_enq.addButForm'
                  :cpntKeyMostra='campos.p_ipi_enq.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_enq.tipoOrder'
                  :cpntOrder='campos.p_ipi_enq.order'
                  :cpntOptions='campos.p_ipi_enq.options'
                  :cpntOptionInicialNome='campos.p_ipi_enq.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_enq.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_enq.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_enq.searchMinimo'
                  :cpntMask='campos.p_ipi_enq.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_enq.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_enq.onChange'
                  :cpntOnBlur='campos.p_ipi_enq.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_enq.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_enq.onKeyPressEnter'
                  ref="p_ipi_enq"
                ></App-Select>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_selo">
                <App-Select :data-time="time" :class="campos.p_ipi_selo.class" class="dem-edi-pro-tab-item-editar--p_ipi_selo"
                  :cpntStatus='campos.p_ipi_selo.status'
                  :cpntId='campos.p_ipi_selo.id'
                  :cpntAlerta='campos.p_ipi_selo.alerta'
                  :cpntTabIndex='campos.p_ipi_selo.tabIndex'
                  :cpntNome='campos.p_ipi_selo.nome'
                  :cpntValue='campos.p_ipi_selo.value'
                  :cpntMensagem='campos.p_ipi_selo.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_selo.mensagemTipo'
                  :cpntDisabled='campos.p_ipi_selo.disabled()'
                  :cpntMostrar='campos.p_ipi_selo.mostrar'
                  :cpntExplica='campos.p_ipi_selo.explica'
                  :cpntPlaceholder='campos.p_ipi_selo.placeholder'
                  :cpntValueRef='campos.p_ipi_selo.valueRef'
                  :cpntRouter='campos.p_ipi_selo.router'
                  :cpntField='campos.p_ipi_selo.field'
                  :cpntWhere='campos.p_ipi_selo.where'
                  :cpntAddButForm='campos.p_ipi_selo.addButForm'
                  :cpntKeyMostra='campos.p_ipi_selo.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_selo.tipoOrder'
                  :cpntOrder='campos.p_ipi_selo.order'
                  :cpntOptions='campos.p_ipi_selo.options'
                  :cpntOptionInicialNome='campos.p_ipi_selo.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_selo.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_selo.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_selo.searchMinimo'
                  :cpntMask='campos.p_ipi_selo.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_selo.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_selo.onChange'
                  :cpntOnBlur='campos.p_ipi_selo.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_selo.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_selo.onKeyPressEnter'
                  ref="p_ipi_selo"
                ></App-Select>
              </div>
            </div>
          </div>
        </template>


        <template v-if="[ 'venda' ].indexOf(cpntDemanda) !== -1">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Estimativa de Impostos
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_fed_bc_v">
                <App-Input :data-time="time" :class="campos.p_fed_bc_v.class" class="dem-edi-pro-tab-item-editar--p_fed_bc_v" 
                  :cpntStatus='campos.p_fed_bc_v.status'
                  :cpntId='campos.p_fed_bc_v.id'
                  :cpntAlerta='campos.p_fed_bc_v.alerta'
                  :cpntClassDivField='campos.p_fed_bc_v.classDivField'
                  :cpntNome='campos.p_fed_bc_v.nome'
                  :cpntValue='campos.p_fed_bc_v.value'
                  :cpntAutoComplete='campos.p_fed_bc_v.autocomplete'
                  :cpntMask='campos.p_fed_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_fed_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_bc_v.optionInicialValue'
                  :cpntDisabled='campos.p_fed_bc_v.disabled()'
                  :cpntMostrar='campos.p_fed_bc_v.mostrar'
                  :cpntExplica='campos.p_fed_bc_v.explica'
                  :cpntAutoFocus='campos.p_fed_bc_v.autofocus'
                  :cpntMensagem='campos.p_fed_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_fed_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_bc_v.placeholder'
                  :cpntPosicionar='campos.p_fed_bc_v.posicionar'
                  :cpntOnChange='campos.p_fed_bc_v.onChange'
                  :cpntOnBlur='campos.p_fed_bc_v.onBlur'
                  ref='p_fed_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_fed_a">
                <App-Input :data-time="time" :class="campos.p_fed_a.class" class="dem-edi-pro-tab-item-editar--p_fed_a" 
                  :cpntStatus='campos.p_fed_a.status'
                  :cpntId='campos.p_fed_a.id'
                  :cpntAlerta='campos.p_fed_a.alerta'
                  :cpntClassDivField='campos.p_fed_a.classDivField'
                  :cpntNome='campos.p_fed_a.nome'
                  :cpntValue='campos.p_fed_a.value'
                  :cpntAutoComplete='campos.p_fed_a.autocomplete'
                  :cpntMask='campos.p_fed_a.mask'
                  :cpntOptionInicialNome='campos.p_fed_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_a.optionInicialValue'
                  :cpntDisabled='campos.p_fed_a.disabled()'
                  :cpntMostrar='campos.p_fed_a.mostrar'
                  :cpntExplica='campos.p_fed_a.explica'
                  :cpntAutoFocus='campos.p_fed_a.autofocus'
                  :cpntMensagem='campos.p_fed_a.mensagem'
                  :cpntMensagemTipo='campos.p_fed_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_a.placeholder'
                  :cpntPosicionar='campos.p_fed_a.posicionar'
                  :cpntOnChange='campos.p_fed_a.onChange'
                  :cpntOnBlur='campos.p_fed_a.onBlur'
                  ref='p_fed_a'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_fed_v">
                <App-Input :data-time="time" :class="campos.p_fed_v.class" class="dem-edi-pro-tab-item-editar--p_fed_v"
                  :cpntStatus='campos.p_fed_v.status'
                  :cpntId='campos.p_fed_v.id'
                  :cpntAlerta='campos.p_fed_v.alerta'
                  :cpntClassDivField='campos.p_fed_v.classDivField'
                  :cpntNome='campos.p_fed_v.nome'
                  :cpntValue='campos.p_fed_v.value'
                  :cpntAutoComplete='campos.p_fed_v.autocomplete'
                  :cpntMask='campos.p_fed_v.mask'
                  :cpntOptionInicialNome='campos.p_fed_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_v.optionInicialValue'
                  :cpntDisabled='campos.p_fed_v.disabled()'
                  :cpntMostrar='campos.p_fed_v.mostrar'
                  :cpntExplica='campos.p_fed_v.explica'
                  :cpntAutoFocus='campos.p_fed_v.autofocus'
                  :cpntMensagem='campos.p_fed_v.mensagem'
                  :cpntMensagemTipo='campos.p_fed_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_v.placeholder'
                  :cpntPosicionar='campos.p_fed_v.posicionar'
                  :cpntOnChange='campos.p_fed_v.onChange'
                  :cpntOnBlur='campos.p_fed_v.onBlur'
                  ref='p_fed_v'
                ></App-Input>
              </div>
            </div>
            
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_est_bc_v">
                <App-Input :data-time="time" :class="campos.p_est_bc_v.class" class="dem-edi-pro-tab-item-editar--p_est_bc_v" 
                  :cpntStatus='campos.p_est_bc_v.status'
                  :cpntId='campos.p_est_bc_v.id'
                  :cpntAlerta='campos.p_est_bc_v.alerta'
                  :cpntClassDivField='campos.p_est_bc_v.classDivField'
                  :cpntNome='campos.p_est_bc_v.nome'
                  :cpntValue='campos.p_est_bc_v.value'
                  :cpntAutoComplete='campos.p_est_bc_v.autocomplete'
                  :cpntMask='campos.p_est_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_est_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_bc_v.optionInicialValue'
                  :cpntDisabled='campos.p_est_bc_v.disabled()'
                  :cpntMostrar='campos.p_est_bc_v.mostrar'
                  :cpntExplica='campos.p_est_bc_v.explica'
                  :cpntAutoFocus='campos.p_est_bc_v.autofocus'
                  :cpntMensagem='campos.p_est_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_est_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_bc_v.placeholder'
                  :cpntPosicionar='campos.p_est_bc_v.posicionar'
                  :cpntOnChange='campos.p_est_bc_v.onChange'
                  :cpntOnBlur='campos.p_est_bc_v.onBlur'
                  ref='p_est_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_est_a">
                <App-Input :data-time="time" :class="campos.p_est_a.class" class="dem-edi-pro-tab-item-editar--p_est_a" 
                  :cpntStatus='campos.p_est_a.status'
                  :cpntId='campos.p_est_a.id'
                  :cpntAlerta='campos.p_est_a.alerta'
                  :cpntClassDivField='campos.p_est_a.classDivField'
                  :cpntNome='campos.p_est_a.nome'
                  :cpntValue='campos.p_est_a.value'
                  :cpntAutoComplete='campos.p_est_a.autocomplete'
                  :cpntMask='campos.p_est_a.mask'
                  :cpntOptionInicialNome='campos.p_est_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_a.optionInicialValue'
                  :cpntDisabled='campos.p_est_a.disabled()'
                  :cpntMostrar='campos.p_est_a.mostrar'
                  :cpntExplica='campos.p_est_a.explica'
                  :cpntAutoFocus='campos.p_est_a.autofocus'
                  :cpntMensagem='campos.p_est_a.mensagem'
                  :cpntMensagemTipo='campos.p_est_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_a.placeholder'
                  :cpntPosicionar='campos.p_est_a.posicionar'
                  :cpntOnChange='campos.p_est_a.onChange'
                  :cpntOnBlur='campos.p_est_a.onBlur'
                  ref='p_est_a'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_est_v">
                <App-Input :data-time="time" :class="campos.p_est_v.class" class="dem-edi-pro-tab-item-editar--p_est_v"
                  :cpntStatus='campos.p_est_v.status'
                  :cpntId='campos.p_est_v.id'
                  :cpntAlerta='campos.p_est_v.alerta'
                  :cpntClassDivField='campos.p_est_v.classDivField'
                  :cpntNome='campos.p_est_v.nome'
                  :cpntValue='campos.p_est_v.value'
                  :cpntAutoComplete='campos.p_est_v.autocomplete'
                  :cpntMask='campos.p_est_v.mask'
                  :cpntOptionInicialNome='campos.p_est_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_v.optionInicialValue'
                  :cpntDisabled='campos.p_est_v.disabled()'
                  :cpntMostrar='campos.p_est_v.mostrar'
                  :cpntExplica='campos.p_est_v.explica'
                  :cpntAutoFocus='campos.p_est_v.autofocus'
                  :cpntMensagem='campos.p_est_v.mensagem'
                  :cpntMensagemTipo='campos.p_est_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_v.placeholder'
                  :cpntPosicionar='campos.p_est_v.posicionar'
                  :cpntOnChange='campos.p_est_v.onChange'
                  :cpntOnBlur='campos.p_est_v.onBlur'
                  ref='p_est_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<style scoped>
  .dem-pro-item-2 {
    max-width: 900px;
    min-width: 700px;
    margin: 0px auto;
    text-align: left;
  }
  .dem-pro-item-2 > .separacao > div > div:first-child {
    padding-top: 10px;
  }
  .dem-pro-item-2 > .separacao > div > div:not(:first-child) {
    padding-top: 22px;
  }
  .dem-pro-item-2 > .separacao > div:not(:first-child) > div > div {
    vertical-align: top;
    display: inline-block;
  }
  .titulo {
    margin-top: 5px;
    font-weight: bold;
    margin-bottom: -2px;
    text-align: left;
  }
  .quadrado {
    background: #f9f9f9;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
  }
    .dem-edi-pro-tab-item-editar--mascaramento {
      width: 170px;
      float: left;
      margin-top: -15px;
      margin-bottom: 2px !important;
    }
    .dem-edi-pro-tab-item-editar--salvar {
      width: 130px;
      float: right;
      margin-top: -15px;
      margin-bottom: 2px !important;
    }
    .dem-edi-pro-tab-item-editar--id_pro_nome {
      width: calc(100% - (150px * 4));
      margin-right: 10px;
    }
    .dem-edi-pro-tab-item-editar--id_pro_codigo,
    .dem-edi-pro-tab-item-editar--qtde,
    .dem-edi-pro-tab-item-editar--valor_uni,
    .dem-edi-pro-tab-item-editar--valor_tot {
      width: calc(150px - 10px);
    }
    .dem-edi-pro-tab-item-editar--valor_fre,
    .dem-edi-pro-tab-item-editar--valor_seg,
    .dem-edi-pro-tab-item-editar--valor_des,
    .dem-edi-pro-tab-item-editar--valor_oda,
    .dem-edi-pro-tab-item-editar--sub_total {
      width: calc((100% / 5) - (40px / 5));
    }

    /* .dem-edi-pro-tab-item-editar--p_id_caso:not(.cpnt-app-campo) {
      width: 200px;
      margin-right: 10px;
      vertical-align: top;
      display: inline-block;
    } */
    .dem-edi-pro-tab-item-editar--p_id_cfop:not(.cpnt-app-campo) {
      width: calc(100%);
      /* width: calc(100% - 200px - 10px); */
      vertical-align: top;
      display: inline-block;
    }
    .dem-edi-pro-tab-item-editar--p_icms_origem:not(.cpnt-app-campo) {
      width: 200px;
      margin-right: 10px;
    }
    .dem-edi-pro-tab-item-editar--p_icms_cst:not(.cpnt-app-campo) {
      width: calc(100% - 200px - 10px);
    }
    .dem-edi-pro-tab-item-editar--p_icms_bc_mod:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_st_bc_mod:not(.cpnt-app-campo) {
      width: 120px;
    }
    .dem-edi-pro-tab-item-editar--p_icms_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_bc_p_r:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_v:not(.cpnt-app-campo),

    .dem-edi-pro-tab-item-editar--p_icms_mva_p:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_st_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_st_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_bc_st_p_r:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_st_v:not(.cpnt-app-campo) {
      width: calc(((100% - 120px) / 5) - 10px);
      margin-left: 10px;
    }

    .dem-edi-pro-tab-item-editar--p_pis_cst:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_cst:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_cst:not(.cpnt-app-campo) {
      width: 200px;
    }
    .dem-edi-pro-tab-item-editar--p_pis_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_pis_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_pis_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_v:not(.cpnt-app-campo) {
      width: calc(((100% - 200px) / 3) - 10px);
    }

    .dem-edi-pro-tab-item-editar--id_pro_codigo,
    .dem-edi-pro-tab-item-editar--id_pro_nome,
    .dem-edi-pro-tab-item-editar--qtde,
    .dem-edi-pro-tab-item-editar--valor_uni,
    .dem-edi-pro-tab-item-editar--valor_fre,
    .dem-edi-pro-tab-item-editar--valor_seg,
    .dem-edi-pro-tab-item-editar--valor_des,
    .dem-edi-pro-tab-item-editar--valor_oda,
    .dem-edi-pro-tab-item-editar--p_pis_cst:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_pis_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_pis_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_cst:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_cofins_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_cst:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_enq:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_devol_p,
    .dem-edi-pro-tab-item-editar--p_fed_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_fed_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_est_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_est_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_a_cf:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_bc:not(.cpnt-app-campo) {
      margin-right: 10px;
    }

    .dem-edi-pro-tab-item-editar--p_ipi_devol_p:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_devol_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_selo:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_ipi_enq:not(.cpnt-app-campo) {
      width: calc(50% - 5px);
    }

    .dem-edi-pro-tab-item-editar--p_icms_fcp_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_a_cf:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_bc:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_icms_fcp_st_r_a:not(.cpnt-app-campo),

    .dem-edi-pro-tab-item-editar--p_fed_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_fed_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_fed_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_est_bc_v:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_est_a:not(.cpnt-app-campo),
    .dem-edi-pro-tab-item-editar--p_est_v:not(.cpnt-app-campo) {
      width: calc((100% / 3) - (20px / 3));
    }

  .p_doc_manual > .dem-edi-pro-tab-item-editar--p_ipi_v,
  .p_doc_manual > .dem-edi-pro-tab-item-editar--p_icms_st_v,
  .p_doc_manual > .dem-edi-pro-tab-item-editar--sub_total {
/*    width: calc((100% / 3) - (20px / 3));*/
    width: calc(((100% - 135px) / 3) - (30px / 3));
  }
  .p_doc_manual > .dem-edi-pro-tab-item-editar--p_ipi_v,
  .p_doc_manual > .dem-edi-pro-tab-item-editar--p_icms_st_v {
    margin-right: 10px;
  }

.dem-edi-pro-tab-item-editar--valor_des {
  width: 135px;
  display: inline-block;
  text-align: left;
  margin-top: -2px;
}
  .dem-edi-pro-tab-item-editar--valor_des_t {
    width: 50px !important;
    margin-right: 2px;
  }
  .dem-edi-pro-tab-item-editar--valor_des_p {
    width: calc(100% - 52px) !important;
  }
  .dem-edi-pro-tab-item-editar--valor_des_v {
    width: calc(100% - 52px) !important;
  }
</style>

<style>
  .dem-edi-pro-tab-item-editar--valor_des > .dem-edi-pro-tab-item-editar--valor_des_t > label,
  .dem-edi-pro-tab-item-editar--valor_des > .dem-edi-pro-tab-item-editar--valor_des_p > label,
  .dem-edi-pro-tab-item-editar--valor_des > .dem-edi-pro-tab-item-editar--valor_des_v > label {
/*    text-wrap: nowrap;*/
    margin-top: -2px;
/*    margin-left: -5px;*/
  }
  .dem-pro-item-2 > .separacao > div > div > .cpnt-app-campo > label,
  .dem-pro-item-2 > .separacao > div > div > div:not(.desconto) > .cpnt-app-campo > label {
    top: -15px !important;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntItemId: {
        required: true
      },
      cpntEditar: {
        required: false,
        default: function () {
          return true
        }
      },
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          mascaramento: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--mascaramento',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '',
            value: true,
            on: 'Protegido',
            off: 'Desprotegido',
            width: '170px',
            title: { mensagem: 'Modo Protegido: O sistema desativa os campos que não deveriam ser preenchidos. (Exemplo: CSOSN = 102 não se deve preencher Mod. BC ST - Modalidade de Base de Cálculo da ST)<br/><br/>Modo Desprotegido: Todos os campos são liberados para modificação.' },
            onChange: this.demEdiProTabItemEditarOnChangeValue
          },
          id_pro_codigo: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--id_pro_codigo',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Código',
            value: '',
            mostrar: true,
            disabled: () => { return true },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          id_pro_nome: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--id_pro_nome',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Nome',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            value: '',
            valueIni: '',
            valueRef: '',
            mostrar: true,
            disabled: () => { return true },
            onRealizaBusca: this.demEdiProFormOnRealizarBusca,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          qtde: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--qtde',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Quantidade',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'qtde',
            value: '1,00',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_uni: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_uni',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Unitário (R$)',
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_uni',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_tot: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_tot',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Total (R$)',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return true },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_fre: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_fre',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Frete (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_fre',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            explica: { mensagem: 'Insira o valor total do frete (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_seg: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_seg',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Seguro (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_seg',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            explica: { mensagem: 'Insira o valor total do seguro (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_des: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_des',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Desconto (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_des',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            explica: { mensagem: 'Insira o valor total do desconto (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_des_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_des_v',
            status: '',
            tabIndex: 17021101,
            nome: 'Valor desconto',
            value: '',
            mostrar: true,
            mask: 'valorMoeda',
            apiEnv: 'valor_des_fixo',
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue
          },
          valor_des_p: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_des_p',
            status: '',
            tabIndex: 17021101,
            nome: '% desconto',
            value: '',
            mostrar: true,
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_des_por',
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue
          },
          valor_des_t: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_des_t',
            status: '',
            tabIndex: 17021100,
            options: [
              { id: 'R$', api: 'valor' },
              { id: '%', api: 'porcentagem' }
            ],
            keyMostra: [ 'id' ],
            keyValue: 'id',
            nome: 'Tipo',
            value: '',
            mostrar: true,
            mask: '',
            explica: { mensagem: 'Tipo de desconto' },
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue
          },
          valor_oda: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--valor_oda',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor O.D.A. (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_oda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            explica: { mensagem: 'Insira o valor total de outras despesas acessórias (este valor não será mutiplicado pela quantidade)', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          
          sub_total: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--sub_total',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Subtotal (R$)',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: () => { return true },
            explica: { mensagem: '(Quantidade * Valor Unitário) + Valor Frete + Valor Seguro - Valor Desconto + Valor Outras Despesas Acessorias', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          xPed: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--xPed',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Nº do Pedido',
            explica: { mensagem: 'Número do Pedido de Compra' },
            value: '',
            valueIni: '',
            apiEnv: 'xPed',
            mostrar: true,
            disabled: () => { return this.dados.nfEmitida !== false },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          // p_id_caso: {
          //   id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_id_caso',
          //   status: '',
          //   alterado: false,
          //   class: '',
          //   alerta: '',
          //   nome: 'Caso',
          //   keyValue: 'id',
          //   keyMostra: [ '_id_caso_nome' ],
          //   options: [],
          //   optionInicialNome: '',
          //   value: '',
          //   valueIni: '',
          //   mostrar: true,
          //   disabled: () => { return this.dados.nfEmitida !== false },
          //   apiEnv: 'id_pro_sf',
          //   onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCasos,
          //   onChange: this.demEdiProTabItemEditarOnChangeValue,
          //   onBlur: this.demEdiProTabItemEditarOnBlur,
          //   onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          // },
          p_id_cfop: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_id_cfop',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'CFOP',
            keyValue: 'cfop',
            keyMostra: [ 'cfop', ' - ', 'descricao' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_id_cfop',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCFOP,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_origem: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_origem',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Origem',
            keyValue: 'ref_icms_origem_id',
            keyMostra: [ 'ref_icms_origem_id', ' - ', 'ref_icms_origem_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_icms_orig',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsOrigem,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_cst: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_cst',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            keyValue: 'ref_icms_cst',
            keyMostra: [ 'ref_icms_cst', ' - ', 'ref_icms_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_icms_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstIcms,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_icms_bc_mod: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_bc_mod',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Mod. BC',
            keyValue: 'ref_icms_mod_bc_id',
            keyMostra: [ 'ref_icms_mod_bc_id', ' - ', 'ref_icms_mod_bc_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_bc_mod', 'p_icms_cst', 'ref_icms_bc_mod') === true },
            apiEnv: 'p_icms_bc_mod',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsModBc,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'BC ICMS',
            mask: 'valorMoeda',
            explica: { mensagem: 'Base de cálculo ICMS' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_bc_v', 'p_icms_cst', 'ref_icms_a') === true },
            apiEnv: 'p_icms_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% ICMS',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_a', 'p_icms_cst', 'ref_icms_a') === true },
            apiEnv: 'p_icms_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_p_r: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_bc_p_r',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% Redução',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_bc_p_r', 'p_icms_cst', 'ref_icms_bc_p_r') === true },
            apiEnv: 'p_icms_bc_p_r',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor ICMS',
            mask: 'valorMoeda',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_v', 'p_icms_cst', 'ref_icms_a') === true },
            apiEnv: 'p_icms_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_p_r_c: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_bc_p_r_c',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Sobre',
            keyValue: 'id',
            keyMostra: [ 'descricao' ],
            options: [],
            optionInicialNome: '',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_bc_p_r_c', 'p_icms_cst', 'ref_icms_bc_p_r_c') === true },
            apiEnv: 'p_icms_bc_p_r_c',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsRedSobre,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_icms_st_bc_mod: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_st_bc_mod',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Mod. BC ST',
            keyValue: 'ref_icms_mod_bc_st_id',
            keyMostra: [ 'ref_icms_mod_bc_st_id', ' - ', 'ref_icms_mod_bc_st_desc' ],
            options: [],
            optionInicialNome: 'Não aplicável',
            optionInicialValue: '-1',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_st_bc_mod', 'p_icms_cst', 'ref_icms_st_bc_mod') === true },
            apiEnv: 'p_icms_st_bc_mod',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsModBcSt,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_mva_p: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_mva_p',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'MVA %',
            mask: 'valorMoeda',
            explica: { mensagem: 'Margem de Valor Agregado<br/><br/>A Margem de Valor Agregado (MVA) é uma porcentagem definida pelas Secretarias da Fazenda dos governos estaduais que incide sobre um grupo de produtos.<br/><br/>Ela tem por objetivo presumir uma margem de lucro para a empresa na primeira etapa da produção. Pois, nesse momento a companhia define o preço final do produto.<br/><br/>Por meio da Margem de Valor Agregado é feito o cálculo do ICMS que será pago nas operações em que se utiliza a substituição tributária.<br/><br/>Além disso, a MVA surgiu para dar maior equilíbrio no mercado. Uma vez que se ela não existisse, haveria uma vantagem competitiva desleal entre as empresas apenas por uma pertencer a determinado estado e ter uma alíquota diferente para pagar.<br/><br/>Com o ajuste feito, baseado na Margem de Valor Agregado, há um equilíbrio nesse imposto que determina e influencia o preço final do produto, levando em consideração as negociações interestaduais.' },
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoStDisabled('p_icms_mva_p', 'ref_icms_mva_p') === true },
            apiEnv: 'p_icms_mva_p',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_st_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'BC ICMS ST',
            mask: 'valorMoeda',
            explica: { mensagem: 'Base de cálculo ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoStDisabled('p_icms_st_bc_v', 'ref_icms_st_a') === true },
            apiEnv: 'p_icms_st_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_st_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% ICMS ST',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoStDisabled('p_icms_st_a', 'ref_icms_st_a') === true },
            apiEnv: 'p_icms_st_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_st_p_r: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_bc_st_p_r',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Redução ST %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoStDisabled('p_icms_bc_st_p_r', 'ref_icms_bc_st_p_r') === true },
            apiEnv: 'p_icms_bc_st_p_r',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_st_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor ICMS ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            disabled: () => { 
              if ([ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.dados.demanda_p_doc_tp) === -1) {
                return false
              } else {
                return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoStDisabled('p_icms_st_v', 'ref_icms_st_a') === true
              }
            },
            apiEnv: 'p_icms_st_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_icms_fcp_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_bc_v', 'p_icms_cst', 'ref_icms_fcp_a') === true },
            apiEnv: 'p_icms_fcp_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_a', 'p_icms_cst', 'ref_icms_fcp_a') === true },
            apiEnv: 'p_icms_fcp_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_v', 'p_icms_cst', 'ref_icms_fcp_a') === true },
            apiEnv: 'p_icms_fcp_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Base de cálculo ST',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_bc_v', 'p_icms_cst', 'ref_icms_fcp_st_a') === true },
            apiEnv: 'p_icms_fcp_st_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota ST %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_a', 'p_icms_cst', 'ref_icms_fcp_st_a') === true },
            apiEnv: 'p_icms_fcp_st_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor ST',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_v', 'p_icms_cst', 'ref_icms_fcp_st_a') === true },
            apiEnv: 'p_icms_fcp_st_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_a_cf: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_a_cf',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% Suportada pelo Consumidor Final',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_a_cf', 'p_icms_cst', 'ref_icms_fcp_st_a_cf') === true },
            apiEnv: 'p_icms_fcp_st_a_cf',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_r_bc: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_r_bc',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor BC retido por ST',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_r_bc', 'p_icms_cst', 'ref_icms_fcp_st_r_bc') === true },
            apiEnv: 'p_icms_fcp_st_r_bc',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_fcp_st_r_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_icms_fcp_st_r_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% do FCP retido por ST',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_icms_fcp_st_r_a', 'p_icms_cst', 'p_icms_fcp_st_r_a') === true },
            apiEnv: 'p_icms_fcp_st_r_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_pis_cst: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_pis_cst',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_pis_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstPisCofins,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_pis_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_pis_bc_v', 'p_pis_cst', 'ref_pc_a') === true },
            apiEnv: 'p_pis_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_pis_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_pis_a', 'p_pis_cst', 'ref_pc_a') === true },
            apiEnv: 'p_pis_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_pis_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_pis_v', 'p_pis_cst', 'ref_pc_a') === true },
            apiEnv: 'p_pis_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_cofins_cst: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_cofins_cst',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_cofins_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstPisCofins,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_cofins_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_cofins_bc_v', 'p_cofins_cst', 'ref_pc_a') === true },
            apiEnv: 'p_cofins_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_cofins_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            value: '0',
            valueIni: '0',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_cofins_a', 'p_cofins_cst', 'ref_pc_a') === true },
            apiEnv: 'p_cofins_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_cofins_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_cofins_v', 'p_cofins_cst', 'ref_pc_a') === true },
            apiEnv: 'p_cofins_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_ipi_cst: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_cst',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'CST',
            keyValue: 'ref_ipi_cst',
            keyMostra: [ 'ref_ipi_cst', ' - ', 'ref_ipi_cst_desc' ],
            options: [],
            optionInicialNome: '',
            optionInicialValue: '',
            // optionInicialNome: 'Não aplicável',
            // optionInicialValue: '-1',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_ipi_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            value: '0',
            valueIni: '0',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_ipi_bc_v', 'p_ipi_cst', 'ref_ipi_a') === true },
            apiEnv: 'p_ipi_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_ipi_a', 'p_ipi_cst', 'ref_ipi_a') === true },
            apiEnv: 'p_ipi_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { 
              if ([ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.dados.demanda_p_doc_tp) === -1) {
                return false
              } else {
                return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_ipi_v', 'p_ipi_cst', 'ref_ipi_a') === true
              }
            },
            apiEnv: 'p_ipi_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_ipi_enq: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_enq',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Enquadramento',
            keyValue: 'ref_ipi_enq',
            keyMostra: [ 'ref_ipi_enq', ' - ', 'ref_ipi_enq_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_ipi_enq', 'p_ipi_cst', 'ref_ipi_enq') === true },
            apiEnv: 'p_ipi_enq',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarEnquadramentoIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_selo: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_selo',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Selo',
            keyValue: 'ref_ipi_selo',
            keyMostra: [ 'ref_ipi_selo', ' - ', 'ref_ipi_tipo', ' - ', 'ref_ipi_cor' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: () => { return this.dados.nfEmitida !== false || this.proSitFisFormularioCampoDisabled('p_ipi_selo', 'p_ipi_cst', 'ref_ipi_selo') === true },
            apiEnv: 'p_ipi_selo',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarSeloIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_devol_p: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_devol_p',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: '% do item devolvido',
            mask: 'numero_decimal',
            value: '0',
            valueIni: '0',
            disabled: () => { return true },
            // apiEnv: 'p_ipi_devol_p',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_devol_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_ipi_devol_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor do IPI devolvido',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return true },
            // apiEnv: 'p_ipi_devol_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_fed_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_fed_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            value: '0',
            valueIni: '0',
            nome: 'BC Tributos Federais',
            mask: 'valorMoeda',
            disabled: () => { return true },
            apiEnv: 'p_fed_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_fed_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_fed_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota % Tributos Federais',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_fed_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_fed_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_fed_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Tributos Federais',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_fed_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_bc_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_est_bc_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            value: '0',
            valueIni: '0',
            nome: 'BC Tributos Estadual',
            mask: 'valorMoeda',
            disabled: () => { return true },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_a: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_est_a',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Alíquota % Tributos Estadual',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_est_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_v: {
            id: 'dem-edi-pro-tab-item-editar-' +  this.cpntItemId + '--p_est_v',
            status: '',
            alterado: false,
            class: '',
            alerta: '',
            nome: 'Valor Tributos Estadual',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            disabled: () => { return this.dados.nfEmitida !== false },
            apiEnv: 'p_est_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onBlur: this.demEdiProTabItemEditarOnBlur,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
        }
      }
    },
    mounted: function () {
      this.demEdiProTabItemEditarIniciar()
    },
    methods: {
      demEdiProTabItemEditarIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiProTabItemEditarSetarStatusGeral('carregando')

        // FAZ A BUSCA DOS DADOS DO PRODUTO QUE ESTÁ EDITANDO
        this.demEdiProTabItemEditarBuscarProduto((dados) => {
          // VERIFICA SE O FORMULARIO ESTÁ PROTEGIDO
          this.campos.mascaramento.value = dados.protegido === 's'
          this.campos.mascaramento.valueIni = dados.protegido === 's'
          this.campos.mascaramento.valueIni2 = dados.protegido === 's'

          // SETA OS DADOS RECEBIDOS
          this.dados = JSON.parse(JSON.stringify(dados))

          // FINALIZA O CARREGAMENTO DOS DADOS
          this.demEdiProTabItemEditarFinalizarCarregamento()
        })
      },
      demEdiProTabItemEditarSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabItemEditarBuscarProduto: function (callback) {
        // INICIA A VARIAVEL QUE VAI RECEBER A ROTA QUE DEVE CHAMAR
        var route = ''

        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          id: null,
          data: null,
          id_pro: { j: { codigo: null, nome: null, id_uni: null, ncm: null, status: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } } },
          qtde: null,
          valor_uni_novo: { a: 'valor_uni' },
          valor_tot_novo: { a: 'valor_tot' },
          valor_fre: null,
          valor_seg: null,
          valor_des_por: null,
          valor_des_fixo: null,
          valor_oda: null,

          p_com_ind: null,
          p_id_cfop: { j: { descricao: null , j_demanda: null } },
          p_icms_orig: { j: { ref_icms_origem_desc: null } },
          p_icms_cst: { j: { ref_icms_rt_id: null, ref_icms_cst_desc: null, ref_icms_aa: null, ref_icms_bc_mod: null, ref_icms_a: null, ref_icms_bc_p_r: null, ref_icms_bc_p_r_c: null, ref_icms_st_bc_mod: null, ref_icms_st_a: null, ref_icms_bc_st_p_r: null, ref_icms_st_bc_rt: null, ref_icms_st_rt: null, ref_icms_mva_p: null, ref_icms_fcp_a: null, ref_icms_fcp_st_a: null, ref_icms_fcp_st_a_cf: null, ref_icms_fcp_st_r_a: null, ref_icms_fcp_st_r_bc: null } },
          p_icms_bc_mod: { j: { ref_icms_mod_bc_desc: null } },
          p_icms_a: null,
          p_icms_bc_p_r: null,
          p_icms_bc_p_r_c: null,
          p_icms_st_bc_mod: { j: { ref_icms_mod_bc_st_desc: null } },
          p_icms_st_a: null,
          p_icms_bc_st_p_r: null,
          p_icms_st_bc_rt: null,
          p_icms_st_rt: null,
          p_icms_mva_p: null,
          p_icms_int_a: null,
          p_icms_int_par_p: null,
          p_icms_fcp_a: null,
          p_icms_fcp_st_a: null,
          p_icms_fcp_st_a_cf: null,
          p_icms_fcp_st_r_a: null,
          p_icms_fcp_st_r_bc: null,
          p_icms_bc_v: null,
          p_icms_v: null,
          p_icms_ope_v: null,
          p_icms_dif_v: null,
          p_icms_st_v: null,
          p_icms_st_bc_v: null,
          p_icms_sn_cre_v: null,
          p_icms_int_uf_des_v: null,
          p_icms_int_uf_rem_v: null,
          p_icms_fcp_bc_v: null,
          p_icms_fcp_v: null,
          p_icms_fcp_st_bc_v: null,
          p_icms_fcp_st_v: null,
          p_icms_fcp_st_r_v: null,

          p_pis_cst: { j: { ref_pc_cst_desc: null, ref_pc_a: null, ref_pc_ope: null } },
          p_pis_a: null,
          p_pis_bc_v: null,
          p_pis_v: null,

          p_cofins_cst: { j: { ref_pc_cst_desc: null, ref_pc_a: null, ref_pc_ope: null } },
          p_cofins_a: null,
          p_cofins_bc_v: null,
          p_cofins_v: null,

          p_ipi_cst: { j: { ref_ipi_cst_desc: null, ref_ipi_ope: null, ref_ipi_a: null, ref_ipi_enq: null, ref_ipi_selo: null } },
          p_ipi_a: null,
          p_ipi_enq: { j: { ref_ipi_enq_desc: null } },
          p_ipi_selo: { j: { ref_ipi_tipo: null, ref_ipi_cor: null } },
          p_ipi_bc_v: null,
          p_ipi_v: null,

          xPed: null,
          p_fed_a: null,
          p_fed_v: null,
          p_est_a: null,
          p_est_v: null,
          status: null,
          protegido: null
        }

        // SETA O CAMPOS VIRTUAL QUE DEVE BUSCAR
        queryGet.field_virtual = [ 'p_icms_bc_p_r_c_desc' ]

        // VERIFICA SE DEVE COMPARAR OS DADOS DO CASO
        if (([ 'NFCe', 'NFe' ].indexOf(this.cpntPDocTp) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) === false) {
          queryGet.field_virtual = queryGet.field_virtual.concat([ 'p_chk_caso' ])
        }

        // VERIFICA O WHERE QUE DEVE REALIZAR
        switch (this.cpntDemanda) {
          case 'venda':
            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [ { f: 'id', o: '=', v: this.cpntItemId }, { f: 'cod_venda', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            route = '/venda/produto/get'

            // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
            queryGet.field = Object.assign(queryGet.field, {
              cod_venda: { j: {
                p_doc_tp: null,
                p_doc_n: null,
                p_doc_docs: { j: { DocNumero: null } },
              } }
            })
            break

          case 'compra':
            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [ { f: 'id', o: '=', v: this.cpntItemId }, { f: 'dem_compra', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            route = '/demanda/dem-compra/dem-produto/get'

            // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
            queryGet.field = Object.assign(queryGet.field, {
              dem_compra: { j: {
                p_doc_tp: null,
                p_doc_n: null,
                p_doc_docs: { j: { DocNumero: null } }
              } }
            })
            break

          case 'dev_cliente':
            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [ { f: 'id', o: '=', v: this.cpntItemId }, { f: 'dem_dev_cliente', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            route = '/demanda/dem-dev-cliente/dem-produto/get'

            // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
            queryGet.field = Object.assign(queryGet.field, {
              dem_dev_cliente: { j: {
                p_doc_tp: null,
                p_doc_n: null,
                p_doc_fin: null,
                p_doc_docs: { j: { DocNumero: null } }
              } },
              p_ipi_devol_p: null,
              p_ipi_devol_v: null
            })
            break

          case 'dev_fornecedor':
            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [ { f: 'id', o: '=', v: this.cpntItemId }, { f: 'dem_dev_fornecedor', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            route = '/demanda/dem-dev-fornecedor/dem-produto/get'

            // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
            queryGet.field = Object.assign(queryGet.field, {
              dem_dev_fornecedor: { j: {
                p_doc_tp: null,
                p_doc_n: null,
                p_doc_fin: null,
                p_doc_docs: { j: { DocNumero: null } }
              } },
              p_ipi_devol_p: null,
              p_ipi_devol_v: null
            })
            break
        }

        // // VERIFICA SE DEVE BUSCAR O CAMPO DESCONTO
        // if ([ '' ] !== 'venda') {
        //   queryGet.field = Object.assign(queryGet.field, { valor_des: null })
        // }
        
        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI(route, 'POST', queryGet, (retorno) => {
          if ([ '', null, undefined ].indexOf(retorno.data) !== -1 || Object.keys(retorno.data).length === 0) {
            this.demEdiProTabItemEditarSetarStatusGeral({ code: '406', message: 'Item (' + this.cpntItemId + ') não foi localizada.' })
          } else {
            // INICIA A VARIAVEL
            retorno.data[0].nfEmitida = false

            // SETA O P_DOC_TP DO REGISTRO
            if ([ 'venda' ].indexOf(this.cpntDemanda) !== -1) {
              retorno.data[0].p_ipi_devol_p = '0,00'
              retorno.data[0].p_ipi_devol_v = '0,00'
              retorno.data[0].demanda_p_doc_tp = retorno.data[0].cod_venda_p_doc_tp
              retorno.data[0].demanda_p_doc_n = retorno.data[0].cod_venda_p_doc_n
              retorno.data[0].demanda_p_doc_docs = retorno.data[0].cod_venda_p_doc_docs
              retorno.data[0].demanda_p_doc_docs_DocNumero = retorno.data[0].cod_venda_p_doc_docs_DocNumero
            } else if ([ 'compra' ].indexOf(this.cpntDemanda) !== -1) {
              retorno.data[0].p_ipi_devol_p = '0,00'
              retorno.data[0].p_ipi_devol_v = '0,00'
              retorno.data[0].demanda_p_doc_tp = retorno.data[0].dem_compra_p_doc_tp
              retorno.data[0].demanda_p_doc_n = retorno.data[0].dem_compra_p_doc_n
              retorno.data[0].demanda_p_doc_docs = retorno.data[0].dem_compra_p_doc_docs
              retorno.data[0].demanda_p_doc_docs_DocNumero = retorno.data[0].dem_compra_p_doc_docs_DocNumero
            } else if ([ 'dev_cliente' ].indexOf(this.cpntDemanda) !== -1) {
              retorno.data[0].demanda_p_doc_tp = retorno.data[0].dem_dev_cliente_p_doc_tp
              retorno.data[0].demanda_p_doc_n = retorno.data[0].dem_dev_cliente_p_doc_n
              retorno.data[0].demanda_p_doc_docs = retorno.data[0].dem_dev_cliente_p_doc_docs
              retorno.data[0].demanda_p_doc_docs_DocNumero = retorno.data[0].dem_dev_cliente_p_doc_docs_DocNumero
              retorno.data[0].demanda_p_doc_fin = retorno.data[0].dem_dev_cliente_p_doc_fin
            } else if ([ 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1) {
              retorno.data[0].demanda_p_doc_tp = retorno.data[0].dem_dev_fornecedor_p_doc_tp
              retorno.data[0].demanda_p_doc_n = retorno.data[0].dem_dev_fornecedor_p_doc_n
              retorno.data[0].demanda_p_doc_docs = retorno.data[0].dem_dev_fornecedor_p_doc_docs
              retorno.data[0].demanda_p_doc_docs_DocNumero = retorno.data[0].dem_dev_fornecedor_p_doc_docs_DocNumero
              retorno.data[0].demanda_p_doc_fin = retorno.data[0].dem_dev_fornecedor_p_doc_fin
            }

            retorno.data[0].tpDesconto = [ '', null, undefined ].indexOf(retorno.data[0].valor_des_por) !== -1 ? 'R$' : '%'
            if ([ '', null, undefined ].indexOf(retorno.data[0].valor_des_por) !== -1) {
              retorno.data[0].valor_des_por = ((Number(retorno.data[0].valor_des_fixo) / Number(retorno.data[0].valor_tot)) * 100).toFixed(2)
            } else {
              retorno.data[0].valor_des_fixo = ((Number(retorno.data[0].valor_tot) * Number(retorno.data[0].valor_des_por)) / 100).toString()
            }

            // VERIFICA SE A NOTA ESTÁ EMITIDA
            retorno.data[0].nfEmitida = ([ '', null, undefined ].indexOf(retorno.data[0].demanda_p_doc_docs) === -1 && [ '', null, undefined ].indexOf(retorno.data[0].demanda_p_doc_docs_DocNumero) === -1 && [ '', null, undefined ].indexOf(retorno.data[0].demanda_p_doc_n) === -1)

            // FORMATA A QUANTIDADE
            retorno.data[0].qtde = Number(retorno.data[0].qtde).toString()

            // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
            retorno.data[0].qtde = retorno.data[0].qtde.split('.')

            // VERIFICA SE É UM NUMERO DECIMAL OU NÃO
            if ((retorno.data[0].qtde.length >= 2 && retorno.data[0].qtde[retorno.data[0].qtde.length -1].length >= 3) === false) {
              if (retorno.data[0].qtde.length === 1) {
                retorno.data[0].qtde.push('00')
              } else if (retorno.data[0].qtde[(retorno.data[0].qtde.length - 1)].length === 1) {
                retorno.data[0].qtde[(retorno.data[0].qtde.length - 1)] = (retorno.data[0].qtde[(retorno.data[0].qtde.length - 1)].toString() + '0')
              }
            }

            // FORMATA A QUANTIDADE
            retorno.data[0].qtde = retorno.data[0].qtde.join('.')

            // PEGA O VALOR UNITARIO RECEBIDO
            var valor_uni = Number(retorno.data[0].valor_uni).toString()

            // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
            valor_uni = valor_uni.split('.')

            // FORMATA O VALOR RECEBIDO
            if (valor_uni[valor_uni.length -1].length >= 3) {
              retorno.data[0].valor_uni = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', retorno.data[0].valor_uni)
            } else {
              // ADICIONA UM ZERO NO FINAL
              if (valor_uni.length === 1) {
                valor_uni.push('00')
              } else if (valor_uni[(valor_uni.length - 1)].length === 1) {
                valor_uni[(valor_uni.length - 1)] = (valor_uni[(valor_uni.length - 1)].toString() + '0')
              }

              // RETORNA O VALOR MONTADO
              valor_uni = valor_uni.join('')

              // FORMATA O VALOR RECEBIDO
              retorno.data[0].valor_uni = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor_uni)
            }

            // FORMATA O VALOR TOTAL
            retorno.data[0].valor_tot = retorno.data[0].valor_tot.replace('.', '')
            
            // VERIFICA SE A NOTA ESTÁ EMITIDA
            if (retorno.data[0].nfEmitida === true) {
              delete retorno.data[0].virtual_p_chk_caso
            }

            // VERIFICA SE TEM DIFERENÇA NOS CASO DOS PRODUTOS
            if ([ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso) === -1) {
              // INICIA O VALOR DO CAMPO
              retorno.data[0].virtual_check_caso = { qtde: 0, diff: {}, caso_atual: '', explica: null }

              // VERIFICA SE TEM ALGUM ERRO
              if (retorno.data[0].virtual_p_chk_caso.code !== '200') {
                // JUNTA OS VALORES RECEBIDOS COM O VALOR DO VETOR
                retorno.data[0].virtual_check_caso.diff = Object.assign(retorno.data[0].virtual_check_caso.diff, retorno.data[0].virtual_p_chk_caso.data)

                // ATUALIZA A QUANTIDADE DE DIFERENÇAS
                retorno.data[0].virtual_check_caso.qtde = Object.keys(retorno.data[0].virtual_check_caso.diff).length

                // SETA A EXPLICAÇÃO
                retorno.data[0].virtual_check_caso.explica = { mensagem: 'Existe(em) ' + retorno.data[0].virtual_check_caso.qtde + ' diferença(s) entre as informações fiscais neste item em relação ao seu cadastro atual. Clique aqui para visualizar as diferenças.', posicaoMy: 'top right', posicaoAt: 'bottom left' }  
              }

              // SETA OS DADOS DO CASO ATUAL
              if ([ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso.ref) === -1 && [ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso.ref.id_caso_atual) === -1) {
                retorno.data[0].virtual_check_caso.caso_atual = retorno.data[0].virtual_p_chk_caso.ref.id_caso_atual
              }
            }
            
            // RETORNA O VALOR ENCONTRADO
            callback(retorno.data[0])
          }
        }, this.demEdiProTabItemEditarSetarStatusGeral)
      },
      demEdiProTabItemEditarTratarValorParaSoma: function (campo) {
        // QUEBRA O VINCULO DO VUE
        var valor = JSON.parse(JSON.stringify(this.campos[campo].value)).toString()

        // REMOVE O PONTO
        while (valor.indexOf('.') !== -1) {
          valor = valor.replace('.', '')
        }

        // REMOVE A VIRGULA
        while (valor.indexOf(',') !== -1) {
          valor = valor.replace(',', '')
        }

        return valor
      },
      demEdiProTabItemEditarCalcularSubTotal: function () {
        // INICIA O VALOR DO CMAPO
        var valor = 0

        // SOMA O VALOR DO CAMPO TOTAL
        valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_tot'))

        // SOMA O VALOR DO CAMPO TOTAL
        valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_fre'))

        // SOMA O VALOR DO CAMPO TOTAL
        valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_seg'))

        // SOMA O VALOR DO CAMPO TOTAL
        valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_oda'))

        // VERIFICA SE É MODELO DE NOTA MANUAL
        if ([ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.dados.demanda_p_doc_tp) === -1) {
          // INICIA O VALOR DO CAMPO
          var valor_tot = 0

          // SOMA O VALOR DO CAMPO TOTAL
          var qtde = this.campos.qtde.value

          // VERIFICA SE É UM NUMERO
          if (isNaN(qtde) === true) {
            // REMOVE O PONTO
            while (qtde.indexOf('.') !== -1) {
              qtde = qtde.replace('.', '')
            }

            // CONVERTE A VIRGULA
            qtde = qtde.replace(',', '.')
          }

          // SOMA O VALOR DO CAMPO TOTAL
          var valor_uni = this.campos.valor_uni.value

          // VERIFICA SE É UM NUMERO
          if (isNaN(valor_uni) === true) {
            // REMOVE O PONTO
            while (valor_uni.indexOf('.') !== -1) {
              valor_uni = valor_uni.replace('.', '')
            }

            // CONVERTE A VIRGULA
            valor_uni = valor_uni.replace(',', '.')
          }

          // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
          valor_uni = valor_uni.split('.')

          // VERIFICA SE É UM NUMERO DECIMAL OU NÃO
          if (valor_uni.length >= 2 && valor_uni[valor_uni.length -1].length >= 3) {
            // CALCULA O VALOR
            valor_tot = (Number(valor_uni.join('.')) * Number(qtde)).toFixed(2)

            // CONVERTE A VIRGULA
            valor_tot = valor_tot.toString().replace('.', '')
          } else {
            // ADICIONA UM ZERO NO FINAL
            if (valor_uni.length === 1) {
              valor_uni.push('00')
            } else if (valor_uni[(valor_uni.length - 1)].length === 1) {
              valor_uni[(valor_uni.length - 1)] = (valor_uni[(valor_uni.length - 1)].toString() + '0')
            }

            // FAZ O CALCULO DO VALOR
            valor_tot = (Number((Number(valor_uni.join('.')) * Number(qtde))) * 100).toFixed(0)
          }

          // SETA O VALOR ATUALIZADO DO CAMPO
          this.campos.valor_tot.value = this.$store.state.FUN_MASK_VALOR('ValorMoeda', valor_tot)

          // SOMA O VALOR DO CAMPO TOTAL
          valor = Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_tot'))

          // SOMA O VALOR DO CAMPO TOTAL
          valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('p_ipi_v'))

          // SOMA O VALOR DO CAMPO TOTAL
          valor += Number(this.demEdiProTabItemEditarTratarValorParaSoma('p_icms_st_v'))
        }


        // DELETE A CHAVE SE NÃO TIVER VALOR VALIDO
        if (this.demEdiProTabItemEditarValorTipoDesconto === 'R$' && [ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(this.campos.valor_des_v.value) === -1) {
          // VERIFICAR O TIPO 
          var valor_des_v = this.campos.valor_des_v.value

          // REMOVE A FORMATAÇÃO 
          if (isNaN(valor_des_v) !== false) {
            // REMOVE OS PONTOS DA STRING
            while (valor_des_v.indexOf('.') !== -1) {
              valor_des_v = valor_des_v.replace('.', '')
            }
            // REMOVE A VIRGULA DA STRING
            while (valor_des_v.indexOf(',') !== -1) {
              valor_des_v = valor_des_v.replace(',', '.')
            }
          }

          // SOMA O VALOR DO CAMPO TOTAL
          valor -= Number(valor_des_v)
        } else if (this.demEdiProTabItemEditarValorTipoDesconto === '%' && [ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(this.campos.valor_des_p.value) === -1) {
          // VERIFICAR O TIPO 
          var valor_des_p = this.campos.valor_des_p.value

          // REMOVE A FORMATAÇÃO 
          if (isNaN(valor_des_p) !== false) {
            // REMOVE OS PONTOS DA STRING
            while (valor_des_p.indexOf('.') !== -1) {
              valor_des_p = valor_des_p.replace('.', '')
            }
            // REMOVE A VIRGULA DA STRING
            while (valor_des_p.indexOf(',') !== -1) {
              valor_des_p = valor_des_p.replace(',', '.')
            }
          }


          // SOMA O VALOR DO CAMPO TOTAL
          valor -= Number((Number(this.demEdiProTabItemEditarTratarValorParaSoma('valor_tot')) * (Number(valor_des_p) / 100)).toFixed(0))
        }
        
        // FORMATA O NUMERO RECEBIDO
        this.campos.sub_total.value = this.$store.state.FUN_MASK_VALOR('ValorMoeda', JSON.parse(JSON.stringify(valor)).toString())

        // SETA O VALOR DA BC ESTIMATIVA DE IMPOSTO ATUALIZADA
        this.campos.p_fed_bc_v.value = this.$store.state.FUN_MASK_VALOR('ValorMoeda', JSON.parse(JSON.stringify(valor)).toString())
        this.campos.p_est_bc_v.value = this.$store.state.FUN_MASK_VALOR('ValorMoeda', JSON.parse(JSON.stringify(valor)).toString())
      },
      demEdiProTabItemEditarFinalizarCarregamento: function () {
        // SETA OS VALORES DO CAMPO
        this.demEdiProTabItemEditarSetarValorCampo('todos', JSON.parse(JSON.stringify(this.dados)), true, true)

        // MANDA CALCULAR O SUBTOTAL
        this.demEdiProTabItemEditarCalcularSubTotal()

        // // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        // const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

        // // VERIFICA SE DEVE COLOCAR COLUNA DE STATUS DO PROCESSO
        // this.dados.status_processo = null
        // if ([ '', null, undefined ].indexOf(this.dados.id_pco_item) === -1) {
        //   this.dados.status_processo = {
        //     tipo: 'venda',
        //     id: this.dados.id_pco_item,
        //     nome: this.dados.id_pco_item_nome,
        //     cor_letra: FUN_VERIFICA_COR_LETRA(this.dados.id_pco_item_cor_fundo),
        //     cor_fundo: this.dados.id_pco_item_cor_fundo
        //   }
        // }

        // SETA O STATUS DA TELA
        this.demEdiProTabItemEditarSetarStatusGeral('')
      },
      demEdiProTabItemEditarSetarValorCampo: function (chaves, vetor, setValueIni = false, setValueIni2 = false, index = 0) {
        // VERIFICA SE TEM QUE BUSCAR
        if (chaves === 'todos') {
          // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
          chaves = Object.keys(this.campos)

          // REMOVE AS CHAVES QUE NÃO PRECISA CALCULAR
          chaves = chaves.filter(item => [ 'sub_total', 'p_fed_bc_v', 'p_est_bc_v', 'mascaramento' ].indexOf(item) === -1)
        } else if (typeof chaves === 'string') {
          chaves = [ chaves ]
        }

        // VERIFICA SE TEM VALOR A SER ATUALIZADO
        if (([ '', null, undefined ].indexOf(chaves) !== -1 || chaves.length === 0 || [ '', null, undefined ].indexOf(chaves[index]) !== -1) === false) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[index]

          // INICIA A VARIAVEL DE VALOR
          var value = ''
          var valueRef = ''
          var alerta = ''
          var options = ([ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1 ? JSON.parse(JSON.stringify(this.campos[chave].options)) : [])

          // VERIFICA O VALOR QUE DEVE SELECIONAR
          switch (chave) {
            case 'id_pro_codigo':
              value = vetor[chave]
              break

            case 'id_pro_nome':
              value = { nome: vetor.id_pro_nome, id_cat_nome: vetor.id_pro_id_cat_nome, id_mar_nome: vetor.id_pro_id_mar_nome, codigo: vetor.id_pro_codigo }
              break

            case 'qtde':
              // value = vetor[chave].replace('.000', '.00')
              value = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', vetor[chave])
              break
              
            case 'p_ipi_devol_p':
              value = ([ '', null, undefined ].indexOf(vetor[chave]) !== -1 ? '0.00' : vetor[chave])
              value = value.replace('.000', '.00')
              break

            case 'xPed':
              value = vetor[chave]
              break

            case 'p_id_caso':
              if (vetor.p_id_sf2_id_caso === undefined) {
                value = vetor.p_id_sf2
              } else {
                // INICIA O NOME DO CASO
                var nome = ''

                // VERIFICA SE TEM CASO SELECIONADO
                if ([ '', null, undefined ].indexOf(vetor.p_id_sf2_id_caso) === -1) {
                  // SETA O NOME DO CASO
                  nome = vetor.p_id_sf2_id_caso_nome

                  // SETA O ESTADO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(vetor.p_id_sf2_id_uf) === -1) {
                    nome += ' | UF: ' + vetor.p_id_sf2_id_uf
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(vetor.p_id_sf2_id_con_nome) === -1) {
                    nome += ' | Contato: ' + vetor.p_id_sf2_id_con_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(vetor.p_id_sf2_ncm) === -1) {
                    nome += ' | NCM: ' + vetor.p_id_sf2_ncm
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(vetor.p_id_sf2_id_pro) === -1) {
                    nome += ' | Produto: ' + vetor.id_pro_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(vetor.p_id_sf2_id_cfop) === -1) {
                    nome += ' | CFOP ' + vetor.p_id_sf2_id_cfop + ' - ' + vetor.p_id_sf2_id_cfop_descricao
                  }
                }

                // VERIFICA SE O CAMPO NÃO EXISTIR, INICIA COM O VALOR EM BRANCO
                if ([ '', null, undefined ].indexOf(vetor.p_id_sf2) !== -1) {
                  vetor.p_id_sf2 = ''
                }

                // SETA O VALOR QUE DEVE COLOCAR NO CMAPO
                value = { id: vetor.p_id_sf2, _id_caso_nome: nome }
              }
              break
              
            case 'p_id_cfop':
              if (vetor.p_id_cfop_descricao === undefined) {
                value = vetor[chave]
              } else {
                value = { cfop: vetor.p_id_cfop, descricao: vetor.p_id_cfop_descricao }
              }
              break
              
            case 'p_icms_origem':
              if (vetor.p_icms_orig_ref_icms_origem_desc === undefined) {
                value = vetor.p_icms_orig
              } else {
                value = { ref_icms_origem_id: vetor.p_icms_orig, ref_icms_origem_desc: vetor.p_icms_orig_ref_icms_origem_desc }
              }
              break
              
            case 'p_icms_cst':
              // SETA O NOME DO CAMPO
              this.campos[chave].nome = (this.$store.state.licenca.rt_id === '3' ? 'CST' : 'CSOSN')

              // SETA O VALOR DO CAMPO
              if (vetor.p_icms_cst_ref_icms_cst_desc === undefined) {
                value = vetor[chave]
              } else {
                value = {
                  ref_icms_cst: vetor.p_icms_cst,
                  ref_icms_rt_id: vetor.p_icms_cst_ref_icms_rt_id,
                  ref_icms_cst_desc: vetor.p_icms_cst_ref_icms_cst_desc,
                  ref_icms_aa: vetor.p_icms_cst_ref_icms_aa,
                  ref_icms_bc_mod: vetor.p_icms_cst_ref_icms_bc_mod,
                  ref_icms_a: vetor.p_icms_cst_ref_icms_a,
                  ref_icms_bc_p_r: vetor.p_icms_cst_ref_icms_bc_p_r,
                  ref_icms_bc_p_r_c: vetor.p_icms_cst_ref_icms_bc_p_r_c,
                  ref_icms_st_bc_mod: vetor.p_icms_cst_ref_icms_st_bc_mod,
                  ref_icms_st_a: vetor.p_icms_cst_ref_icms_st_a,
                  ref_icms_bc_st_p_r: vetor.p_icms_cst_ref_icms_bc_st_p_r,
                  ref_icms_st_bc_rt: vetor.p_icms_cst_ref_icms_st_bc_rt,
                  ref_icms_st_rt: vetor.p_icms_cst_ref_icms_st_rt,
                  ref_icms_mva_p: vetor.p_icms_cst_ref_icms_mva_p,
                  ref_icms_fcp_a: vetor.p_icms_cst_ref_icms_fcp_a,
                  ref_icms_fcp_st_a: vetor.p_icms_cst_ref_icms_fcp_st_a,
                  ref_icms_fcp_st_a_cf: vetor.p_icms_cst_ref_icms_fcp_st_a_cf,
                  ref_icms_fcp_st_r_a: vetor.p_icms_cst_ref_icms_fcp_st_r_a,
                  ref_icms_fcp_st_r_bc: vetor.p_icms_cst_ref_icms_fcp_st_r_bc
                }
              }
              break
              
            case 'p_icms_bc_mod':
              if (vetor.p_icms_bc_mod_ref_icms_mod_bc_desc === undefined) {
                value = vetor.p_icms_bc_mod
              } else {
                value = { ref_icms_mod_bc_id: vetor.p_icms_bc_mod, ref_icms_mod_bc_desc: vetor.p_icms_bc_mod_ref_icms_mod_bc_desc }
              }
              break
              
            case 'valor_des':
              value = [ '', null, undefined ].indexOf(vetor[chave]) !== -1 ? '' : vetor[chave]
              break

            case 'valor_uni':
            case 'valor_tot':
            case 'valor_fre':
            case 'valor_seg':
            case 'valor_oda':
            case 'p_icms_bc_v':
            case 'p_icms_v':
            case 'p_icms_st_bc_v':
            case 'p_icms_st_v':
            case 'p_icms_fcp_bc_v':
            case 'p_icms_fcp_v':
            case 'p_icms_fcp_st_bc_v':
            case 'p_icms_fcp_st_v':
            case 'p_pis_bc_v':
            case 'p_pis_v':
            case 'p_cofins_bc_v':
            case 'p_cofins_v':
            case 'p_ipi_bc_v':
            case 'p_ipi_v':
            case 'p_fed_a':
            case 'p_fed_v':
            case 'p_est_a':
            case 'p_est_v':
              value = vetor[chave]
              break

            case 'p_ipi_devol_v':
              value = Number(vetor[chave] * 100).toFixed(0) // this.$store.state.FUN_MASK_VALOR('valorMoeda', Number(vetor[chave] * 100).toFixed(0))
              break
              
            case 'p_icms_a':
            case 'p_icms_st_a':
            case 'p_icms_bc_st_p_r':
            case 'p_icms_bc_p_r':
            case 'p_icms_mva_p':
            case 'p_icms_fcp_a':
            case 'p_icms_fcp_st_a':
            case 'p_pis_a':
            case 'p_cofins_a':
            case 'p_ipi_a':
              value = ([ '', null, undefined ].indexOf(vetor[chave]) !== -1 ? '0' : vetor[chave])
              break

            case 'p_icms_bc_p_r_c':
              if (vetor.virtual_p_icms_bc_p_r_c_desc === undefined) {
                value = vetor[chave]
              } else {
                value = { id: vetor.p_icms_bc_p_r_c, descricao: vetor.virtual_p_icms_bc_p_r_c_desc }
              }
              break
              
            case 'p_icms_st_bc_mod':
              if (vetor.p_icms_st_bc_mod_ref_icms_mod_bc_st_desc === undefined) {
                value = vetor[chave]
              } else {
                if ([ '', null, undefined ].indexOf(vetor.p_icms_st_bc_mod) !== -1) {
                  value = ''
                } else {
                  value = [ '-1', -1 ].indexOf(vetor.p_icms_st_bc_mod) !== -1 ? { ref_icms_mod_bc_st_id: '-1', ref_icms_mod_bc_st_desc: 'Não aplicável' } : { ref_icms_mod_bc_st_id: vetor.p_icms_st_bc_mod, ref_icms_mod_bc_st_desc: vetor.p_icms_st_bc_mod_ref_icms_mod_bc_st_desc }
                }
              }
              break
              
            case 'p_pis_cst':
              if (vetor.p_pis_cst_ref_pc_cst_desc === undefined) {
                value = vetor[chave]
              } else {
                value = {
                  ref_pc_cst: vetor.p_pis_cst,
                  ref_pc_cst_desc: vetor.p_pis_cst_ref_pc_cst_desc,
                  ref_pc_a: vetor.p_pis_cst_ref_pc_a,
                  ref_pc_ope: vetor.p_pis_cst_ref_pc_ope
                }
              }
              break
              
            case 'p_cofins_cst':
              if (vetor.p_cofins_cst_ref_pc_cst_desc === undefined) {
                value = vetor[chave]
              } else {
                value = {
                  ref_pc_cst: vetor.p_cofins_cst,
                  ref_pc_cst_desc: vetor.p_cofins_cst_ref_pc_cst_desc,
                  ref_pc_a: vetor.p_cofins_cst_ref_pc_a,
                  ref_pc_ope: vetor.p_cofins_cst_ref_pc_ope
                }
              }
              break
              
            case 'p_ipi_cst':
              if (vetor.p_ipi_cst === '') {
                vetor.p_ipi_cst = ' '
              }

              if (vetor.p_ipi_cst_ref_ipi_cst_desc === undefined) {
                value = vetor[chave]
              } else {
                value = [ '-1', -1, '', ' ' ].indexOf(vetor.p_ipi_cst) !== -1 ? { ref_ipi_a: '0', ref_ipi_cst: ' ', ref_ipi_cst_desc: 'Não aplicável', ref_ipi_enq: '0', ref_ipi_ope: '0', ref_ipi_selo: '0' } : {
                  ref_ipi_cst: vetor.p_ipi_cst,
                  ref_ipi_ope: vetor.p_ipi_cst_ref_ipi_ope,
                  ref_ipi_cst_desc: vetor.p_ipi_cst_ref_ipi_cst_desc,
                  ref_ipi_a: vetor.p_ipi_cst_ref_ipi_a,
                  ref_ipi_enq: vetor.p_ipi_cst_ref_ipi_enq,
                  ref_ipi_selo: vetor.p_ipi_cst_ref_ipi_selo
                }
              }
              break
              
            case 'p_ipi_enq':
              if (vetor.p_ipi_enq_ref_ipi_enq_desc === undefined) {
                value = vetor[chave]
              } else {
                value = { ref_ipi_enq: vetor.p_ipi_enq, ref_ipi_enq_desc: vetor.p_ipi_enq_ref_ipi_enq_desc }
              }
              break

            case 'p_ipi_selo':
              if (vetor.p_ipi_selo_ref_ipi_tipo === undefined) {
                value = vetor[chave]
              } else {
                value = { ref_ipi_selo: vetor.p_ipi_selo, ref_ipi_tipo: vetor.p_ipi_selo_ref_ipi_tipo, ref_ipi_cor: vetor.p_ipi_selo_ref_ipi_cor }
              }
              break

            case 'valor_des_t':
              value = vetor.tpDesconto === '%' ? { id: '%' } : { id: 'R$' }
              break

            case 'valor_des_p':
              if ([ '', null, undefined ].indexOf(vetor.valor_des_por) !== -1) {
                vetor.valor_des_por = ''
              }
              value = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', vetor.valor_des_por)
              break

            case 'valor_des_v':
              if ([ '', null, undefined ].indexOf(vetor.valor_des_fixo) !== -1) {
                vetor.valor_des_fixo = ''
              }              
              value = (Number(vetor.valor_des_fixo) * 100).toFixed()              
              break
          }

          // QUEBRA A LIGAÇÃO DO VUE
          value = JSON.parse(JSON.stringify(value))
          
          // PEGA AS OPÇÕES JÁ EXISTENTES NO CAMPO
          if (options.length === 0 && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
            options = JSON.parse(JSON.stringify(this.campos[chave].options))
          }

          // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
          if (options.length >= 1 && typeof value === 'string') {
            // PEGA O VALOR DO CAMPO
            var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

            // SETA O VALOR ENCONTRADO
            value = valor.length === 1 ? valor[0] : value
          }
          
          // VERIFICA SE TEM QUE SELECIONAR UM VALOR
          if ([ '', null, undefined ].indexOf(value) !== -1 && [ 'valorMoeda' ].indexOf(this.campos[chave].mask) !== -1) {
            value = '0'
          }

          // SETA O VALOR ATUALIZADO DO CAMPO
          this.campos[chave].value = value
          this.campos[chave].options = options
          this.campos[chave].valueRef = valueRef

          // SETA O VALOR INICIAL DO CAMPO
          if (setValueIni === true) {
            if (chave === 'valor_uni' && vetor.valor_uni_ini !== undefined) {
              value = vetor.valor_uni_ini
            }
            this.campos[chave].valueIni = value
          }
          if (setValueIni2 === true) {
            if (chave === 'valor_uni' && vetor.valor_uni_ini !== undefined) {
              value = vetor.valor_uni_ini
            }
            this.campos[chave].valueIni2 = value
          }

          // PEGA A CHAVE ENVIADA PARA API
          var apiEnv = this.campos[chave].apiEnv

          // VERIFICA SE TEM CAMPO PARA ENVIAR PAR AAPI
          if ([ '', null, undefined ].indexOf(apiEnv) === -1) {
            // REMOVE O P_ DO NOME DA VARIAVEL
            if (apiEnv.substring(0, 2) === 'p_') {
              apiEnv = apiEnv.substring(2, apiEnv.length)
            }

            // VERIFICA SE TEM O CAMPO PARA APRESENTAR A MENSAGEM DE ERRO
            if ([ '', null, undefined ].indexOf(vetor.virtual_p_chk_caso) === -1 && vetor.virtual_p_chk_caso.code !== '200' && [ '', null, undefined ].indexOf(vetor.virtual_p_chk_caso.data) === -1  && [ '', null, undefined ].indexOf(vetor.virtual_p_chk_caso.data.diff) === -1 && [ '', null, undefined ].indexOf(vetor.virtual_p_chk_caso.data.diff[apiEnv]) === -1) {
              this.campos[chave].alerta = 'Foi encontrado diferença neste campo: <br/><br/>' + vetor.virtual_p_chk_caso.data.diff[apiEnv]

              // // SETA A EXPLICAÇÃO
              // vetor[indexI].virtual_check_caso.explica = { mensagem: 'Existe(em) ' + vetor[indexI].virtual_check_caso.qtde + ' diferença(s) entre as informações fiscais neste item em relação ao seu cadastro atual.<br/><br/>Clique aqui para visualizar as diferenças.', posicaoMy: 'top right', posicaoAt: 'bottom left' }

              // INICIA O ALERTA
              alerta = 'Foi encontrado diferença neste campo: <br/><br/><table class="dem-pro-tab-diff">'

              // SETA O TITULO DA ALERTA
              alerta += '<tr>'
                alerta += '<th>'
                  alerta += 'Campo'
                alerta += '</th>'

                alerta += '<th>'
                  alerta += 'Devolução'
                alerta += '</th>'

                alerta += '<th>'
                  alerta += 'Sit Fiscal'
                alerta += '</th>'
              alerta += '</tr>'

              // JUNTA OS VALORES NOS CAMPOS
              alerta += '<tr>'
                alerta += '<td>'
                  alerta += apiEnv
                alerta += '</td>'

                alerta += '<td>'
                  alerta += vetor.virtual_p_chk_caso.data.diff[apiEnv].ven_pro
                alerta += '</td>'

                alerta += '<td>'
                  alerta += vetor.virtual_p_chk_caso.data.diff[apiEnv].sit_fiscal
                alerta += '</td>'
              alerta += '</tr>'
              
              // FINALIZA A ALERTA
              alerta += '</table>'
            }
          }

          // SETA A alerta
          this.campos[chave].alerta = alerta

          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          this.demEdiProTabItemEditarSetarValorCampo(chaves, vetor, setValueIni, setValueIni2, (index + 1))
        } else {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      demEdiProTabItemEditarOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[indexF].value = value

        // SETA QUE O VALOR FOI ALTERADO
        this.campos[indexF].alterado = (this.campos[indexF].valueIni !== value)

        // SETA A CLASSE DO CAMPO
        if ([ 'valor_tot' ].indexOf(indexF) === -1 && this.campos[indexF].alterado === true) {
          // LIMPA O VALOR INICIAL PARA FORÇAR A ATUALIZAÇÃO
          this.campos[indexF].valueIni2 = '-'

          // SETA A CLASSE PARA O FUNDO FICAR AMARELO
          this.campos[indexF].class = 'rf-field-destaque-busca_api'
        }

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.campos[indexF].mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A FUNÇÃO QUE DEVE EXECUTAR PARA CADA CAMPO ATUALIZADO
        switch (indexF) {
          case 'valor_tot':
          case 'valor_fre':
          case 'valor_seg':
          case 'valor_des_t':
          case 'valor_des_p':
          case 'valor_des_v':
          case 'valor_oda':
            this.demEdiProTabItemEditarCalcularSubTotal()
            break

          case 'qtde':
          case 'valor_uni':
          case 'p_ipi_v':
          case 'p_icms_st_v':
            if ([ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.dados.demanda_p_doc_tp) === -1) {
              this.demEdiProTabItemEditarCalcularSubTotal()
            }
            break

          case 'p_id_cfop':
          case 'p_icms_cst':
          case 'p_icms_st_bc_mod':
          case 'p_pis_cst':
          case 'p_cofins_cst':
          case 'p_ipi_cst':
          case 'p_icms_bc_p_r_c':
            this.demEdiProTabItemEditarSimularValor(indexF)
            break
        }
      },
      demEdiProTabItemEditarSimularValor: function (chave) {
        // PEGA O VALOR PARA COMPRAR
        var valor = this.campos[chave].value
        var valueIni2 = this.campos[chave].valueIni2

        // CONVERTE O VALOR RECEBIDO
        if (chave === 'valor_uni') {
          valor = this.demEdiProTabItemTratarValorUnitario(this.$refs.valor_uni.value)
          valueIni2 = this.campos[chave].valueIni2 === '-' ? this.campos[chave].valueIni2 : this.demEdiProTabItemTratarValorUnitario(this.campos[chave].valueIni2)
        }
        
        // VERIFICA SE HOUVE ALTERAÇÃO NO VALOR
        if ((isNaN(valor) === false && Number(valor) !== Number(valueIni2)) || (isNaN(valor) === true && JSON.stringify(this.campos[chave].value) !== JSON.stringify(valueIni2))) {
          if (this.campos.mascaramento.value === true && [ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.dados.demanda_p_doc_tp) !== -1) {
            this.demEdiProTabItemSimularValores()
          }
        }
      },
      demEdiProTabItemEditarOnBlur: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]

        // VERIFICA O CAMPO QUE DEVE REALIZAR ALGUMA AÇÃO
        switch (indexF) {
          case 'qtde':
          case 'valor_uni':
          case 'valor_tot':
          case 'valor_fre':
          case 'valor_seg':
          case 'valor_oda':
          case 'sub_total':
          case 'p_icms_a':
          case 'p_icms_bc_p_r':
          case 'p_icms_st_a':
          case 'p_icms_bc_st_p_r':
          case 'p_icms_fcp_a':
          case 'p_icms_fcp_st_a':
          case 'p_pis_bc_v':
          case 'p_pis_a':
          case 'p_pis_v':
          case 'p_cofins_bc_v':
          case 'p_cofins_a':
          case 'p_cofins_v':
          case 'p_ipi_bc_v':
          case 'p_ipi_a':
          case 'p_ipi_v':
          case 'p_icms_bc_v':
          case 'p_icms_v':
          case 'p_icms_ope_v':
          case 'p_icms_dif_v':
          case 'p_icms_st_bc_v':
          case 'p_icms_st_v':
          case 'p_icms_mva_p':
          case 'p_icms_sn_cre_v':
          case 'p_icms_int_uf_des_v':
          case 'p_icms_int_uf_rem_v':
          case 'p_icms_fcp_bc_v':
          case 'p_icms_fcp_v':
          case 'p_icms_fcp_st_bc_v':
          case 'p_icms_fcp_st_v':
          case 'p_icms_fcp_st_r_v':
          case 'p_fed_a':
          case 'p_fed_v':
          case 'p_est_a':
          case 'p_est_v':
            this.demEdiProTabItemEditarSimularValor(indexF)
            break
        }
      },
      demEdiProTabItemTratarValorUnitario: function (valor) {
        // QUEBRA O VINCULO DO VUE
        valor = JSON.parse(JSON.stringify(valor))

        // CONVERTE O VALOR
        if (isNaN(valor) === true) {
          // REMOVE O PONTO
          while (valor.indexOf('.') !== -1) {
            valor = valor.replace('.', '')
          }

          // CONVERTE A VIRGULA
          valor = valor.replace(',', '.')
        } 

        // SEPARA O VALOR RECEBIDO
        valor = valor.split('.')

        // ADICIONA UM ZERO NO FINAL
        if (valor.length === 1) {
          valor.push('00')
        } else if (valor[(valor.length - 1)].length === 1) {
          valor[(valor.length - 1)] = (valor[(valor.length - 1)].toString() + '0')
        }

        // RETORNA O VALOR MONTADO
        return valor.join('.')
      },
      demEdiProTabItemSimularValores: function () {
        this.demEdiProTabItemEditarBuscarProduto((dados) => {
          this.demEdiProTabItemMontarFormularioApi((formData) => {
            if ([ '', null, undefined ].indexOf(formData.valor_uni) === -1) {
              // SETA O NOVO VALOR DO CAMPO
              formData.valor_uni_novo = this.$refs.valor_uni.value

              // CONVERTE O VALOR
              if (isNaN(formData.valor_uni_novo) === true) {
                // REMOVE O PONTO
                while (formData.valor_uni_novo.indexOf('.') !== -1) {
                  formData.valor_uni_novo = formData.valor_uni_novo.replace('.', '')
                }

                // CONVERTE A VIRGULA
                formData.valor_uni_novo = formData.valor_uni_novo.replace(',', '.')
              }

              // DELETA O VALOR DO CAMPO ANTIGO
              delete formData.valor_uni
            }
            // if (this.cpntDemanda === 'compra') {
            //   if ([ '', null, undefined ].indexOf(formData.valor_uni) === -1) {
            //     // SETA O NOVO VALOR DO CAMPO
            //     formData.valor_uni_novo = this.$refs.valor_uni.value

            //     // CONVERTE O VALOR
            //     if (isNaN(formData.valor_uni_novo) === true) {
            //       // REMOVE O PONTO
            //       while (formData.valor_uni_novo.indexOf('.') !== -1) {
            //         formData.valor_uni_novo = formData.valor_uni_novo.replace('.', '')
            //       }

            //       // CONVERTE A VIRGULA
            //       formData.valor_uni_novo = formData.valor_uni_novo.replace(',', '.')
            //     }

            //     // DELETA O VALOR DO CAMPO ANTIGO
            //     delete formData.valor_uni
            //   }
            // } else if ([ '', null, undefined ].indexOf(formData.valor_uni) === -1) {
            //   if (isNaN(formData.valor_uni) === true) {
            //     // REMOVE O PONTO
            //     while (formData.valor_uni.indexOf('.') !== -1) {
            //       formData.valor_uni = formData.valor_uni.replace('.', '')
            //     }
  
            //     // ALTERA A VIRGULA PARA PONTO
            //     formData.valor_uni = formData.valor_uni.replace(',', '.')
            //   }
            // }

            // VERIFICA PROBLEMA NA ATUALIZAÇÃO
            if (Object.keys(formData).length >= 1) {
              // JUNTA OS VALORES DOS CAMPOS
              dados = Object.assign(dados, JSON.parse(JSON.stringify(formData)))

              // FORMATA O FORMULARIO QUE SERÁ ENVIADO
              formData = { id: this.cpntItemId, simular: formData }
   
              // FAZ A BUSCA DOS DADOS
              this.$store.state.comunicaAPI('/demanda/dem-pro-sim-cal-fiscal/get', 'POST', formData, (retorno) => {
                // JUNTA OS VALORES DOS CAMPOS
                retorno.data = Object.assign(dados, JSON.parse(JSON.stringify(retorno.data)))
  
                // VERIFICA SE TEM QUE ATUALIZAR OS CAMPOS
                if (retorno.data.valor_uni_novo !== undefined) {
                  if (isNaN(retorno.data.valor_uni_novo) === false) {
                    // SEPARA O VALOR RECEBIDO
                    retorno.data.valor_uni_novo = retorno.data.valor_uni_novo.split('.')

                    // ADICIONA UM ZERO NO FINAL
                    if (retorno.data.valor_uni_novo.length === 1) {
                      retorno.data.valor_uni_novo.push('00')
                    } else if (retorno.data.valor_uni_novo[(retorno.data.valor_uni_novo.length - 1)].length === 1) {
                      retorno.data.valor_uni_novo[(retorno.data.valor_uni_novo.length - 1)] = (retorno.data.valor_uni_novo[(retorno.data.valor_uni_novo.length - 1)].toString() + '0')
                    }

                    // JUNTA OS VALORES RECEBIDOS
                    retorno.data.valor_uni_novo = retorno.data.valor_uni_novo.join('.')
                    
                    // VERIFICA COMO DEVE FORMATAR O NUMERO
                    if ([ '', null, undefined ].indexOf(this.$refs.valor_uni) === -1 && this.$refs.valor_uni.usarDecimal === false) {
                      retorno.data.valor_uni = retorno.data.valor_uni_novo.replace('.', '')
                      retorno.data.valor_uni_ini = retorno.data.valor_uni_novo
                    } else {
                      retorno.data.valor_uni = retorno.data.valor_uni_novo
                    }
                  } else {
                    retorno.data.valor_uni = retorno.data.valor_uni_novo
                  }
                }
                if (retorno.data.valor_tot_novo !== undefined) {
                  retorno.data.valor_tot = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', retorno.data.valor_tot_novo)
                }

                if ([ '', null, undefined ].indexOf(retorno.data.valor_uni) === -1 && [ '', null, undefined ].indexOf(this.$refs.valor_uni) === -1 && this.$refs.valor_uni.usarDecimal === true && isNaN(retorno.data.valor_uni) === false) {
                  retorno.data.valor_uni = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', retorno.data.valor_uni)
                }
      
                // SETA OS VALORES DO CAMPO
                this.demEdiProTabItemEditarSetarValorCampo('todos', retorno.data, false, true)
              }, this.demEdiProTabItemEditarSetarStatusGeral)
            }
          }, true)
        })
      },
      demEdiProTabItemMontarFormularioApi: function (callback, alterado = false) {
        // SETA O FORMULARIO SE DEVE CHAMAR OU NÃO A API
        var params = { check_ini: false, disabled: false, alterado: alterado }

        // VERIFICA SE O TIPO DE DOCUMENTO ESTÁ CERTO
        // VERIFICA SE DEVE MANDAR NULL PARA CAMPOS DESATIVADOS
        if ([ '', 'RE', 'NFe(m)' ].indexOf(this.cpntPDocTp) === -1 && alterado === false && this.campos.mascaramento.value === true) {
          params.disabled_set = null
        }

        // // VERIFICA SE DEVE CHECAR O VALOR INICIAL PARA ENVIO DO CAMPO
        // if ([ '', 'RE' ].indexOf(this.cpntPDocTp) === -1) {
        //   params.check_ini = true
        // }
        
        // INICIA A VARIAVEL
        var focus = ''

        // VERIFICA SE É UM SELECT2
        if (document.activeElement.className.indexOf('select2') === -1) {
          focus = document.activeElement.id  
        // } else {
        //   focus = document.activeElement.parentNode.id
        }

        // SEPARA O NOME DO CAMPO QUE ESTAVA COM FOCUS
        focus = focus.split('--')

        // PEGA O NOME DA CHAVE DO VETOR
        focus = focus[focus.length - 1]

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        var FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos, params).then((formData) => {
          // VERIFICA SE DEVE FORMATAR O CAMPO
          // if ([ '', null, undefined ].indexOf(formData.p_fed_v) === -1) {
          //   formData.p_fed_v = (formData.p_fed_v * 100).toFixed(0).toString()
          // }
          // if ([ '', null, undefined ].indexOf(formData.p_est_v) === -1) {
          //   formData.p_est_v = (formData.p_est_v * 100).toFixed(0).toString()
          // }
          // if ([ '', null, undefined ].indexOf(formData.p_pis_v) === -1) {
          //   formData.p_pis_v = (formData.p_pis_v * 100).toFixed(0).toString()
          // }
          // if ([ '', null, undefined ].indexOf(formData.p_cofins_v) === -1) {
          //   formData.p_cofins_v = (formData.p_cofins_v * 100).toFixed(0).toString()
          // }
          // if ([ '', null, undefined ].indexOf(formData.p_ipi_v) === -1) {
          //   formData.p_ipi_v = (formData.p_ipi_v * 100).toFixed(0).toString()
          // }

          // DELETE A CHAVE SE NÃO TIVER VALOR VALIDO
          if (this.demEdiProTabItemEditarValorTipoDesconto === 'R$' || [ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(formData.valor_des_por) !== -1) {
            delete formData.valor_des_por
          } else {
            // REMOVE A FORMATAÇÃO 
            if (isNaN(formData.valor_des_por) !== false) {
              // REMOVE OS PONTOS DA STRING
              while (formData.valor_des_por.indexOf('.') !== -1) {
                formData.valor_des_por = formData.valor_des_por.replace('.', '')
              }
              // REMOVE A VIRGULA DA STRING
              while (formData.valor_des_por.indexOf(',') !== -1) {
                formData.valor_des_por = formData.valor_des_por.replace(',', '.')
              }
            }
          }
          if (this.demEdiProTabItemEditarValorTipoDesconto === '%' || [ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(formData.valor_des_fixo) !== -1) {
            delete formData.valor_des_fixo
          } else {
            // REMOVE A FORMATAÇÃO 
            if (isNaN(formData.valor_des_fixo) !== false) {
              // REMOVE OS PONTOS DA STRING
              while (formData.valor_des_fixo.indexOf('.') !== -1) {
                formData.valor_des_fixo = formData.valor_des_fixo.replace('.', '')
              }
              // REMOVE A VIRGULA DA STRING
              while (formData.valor_des_fixo.indexOf(',') !== -1) {
                formData.valor_des_fixo = formData.valor_des_fixo.replace(',', '.')
              }
            }

            // CONVERTE VALOR EM DECIMAL
            formData.valor_des_fixo = (Number(formData.valor_des_fixo) / 100).toString()
          }

          // REMOVE A CHAVE DESCONTO
          if (formData.valor_des !== undefined) {
            delete formData.valor_des
          }

          // RETORNA O VALOR MONTADO
          callback(formData)

          // SETA O FOCUS NO CAMPO SOLICITADO
          if ([ '', null, undefined ].indexOf(focus) === -1) {
            this.demEdiProTabItemSetaFocusCampo(focus)
          }
        })
      },
      demEdiProTabItemCampoSetarValorInicial: function (disabled, campo) {
        setTimeout(() => {
          // VERIFICA SE TEM QUE SETAR O VALOR INICIAL
          if ([ 'p_icms_mva_p', 'p_icms_st_bc_v', 'p_icms_st_a', 'p_icms_bc_st_p_r', 'p_icms_st_v' ].indexOf(campo) === -1 && disabled === false && [ 'valorMoeda', 'numero_decimal' ].indexOf(this.campos[campo].mask) !== -1 && this.campos[campo].value === '') {
            this.campos[campo].value = '0.00'
          }

          // VERIFICA SE TEM QUE FAZER ALGUMA AÇÃO A MAIS
          switch (disabled + '__' + campo) {
            case 'true__p_icms_bc_mod':
            case 'true__p_ipi_selo':
            case 'true__p_ipi_enq':
              this.campos[campo].optionInicialNome = ''
              this.campos[campo].optionInicialValue = ''
              break

            case 'false__p_icms_bc_mod':
            case 'false__p_ipi_selo':
            case 'false__p_ipi_enq':
              this.campos[campo].optionInicialNome = 'Selecione'
              this.campos[campo].optionInicialValue = ''
              break

            case 'true__p_icms_st_bc_mod':
              this.campos[campo].optionInicialNome = ''
              this.campos[campo].optionInicialValue = ''
              break

            case 'false__p_icms_st_bc_mod':
              // SETA OS VALORES DOS CAMPOS
              this.campos[campo].optionInicialNome = 'Não aplicável'
              this.campos[campo].optionInicialValue = '-1'
              break
          }
        }, 0)
      },
      demEdiProTabItemCampoPegarValoreSelecionado: function (campo, chave) {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var valor = [ '', null, undefined ].indexOf(this.campos[campo].value) !== -1 ? null : this.campos[campo].value

        // VERIFICA O VALOR QUE DEVE RETORNAR
        switch (chave) {
          case '__TODOS__':
            return valor
        
          default:
            return ([ '', null, undefined ].indexOf(valor) !== -1 || [ '', null, undefined ].indexOf(valor[chave]) !== -1) ? null : valor[chave]
        }
      },
      demEdiProTabItemCampoIcmsCstDisabled: function (campo, chave) {
        // PEGA O VALOR DO CAMPO
        var _valor = this.demEdiProTabItemCampoPegarValoreSelecionado(campo, chave)

        // RETORNA O VALOR CALCULADO
        return [ '', null, undefined ].indexOf(_valor) !== -1
      },
      proSitFisFormularioCampoDisabled: function (campo, campoRef, chaveRef) {
        if (this.campos.mascaramento.value !== true) {
          // SETA O VALOR DO CMAPO
          this.demEdiProTabItemCampoSetarValorInicial(false, campo)

          // RETORNA O VALOR MONTADO
          return false
        } else {
          // PEGA O VALOR DO CAMPO
          var _valor = this.demEdiProTabItemCampoPegarValoreSelecionado(campoRef, chaveRef)

          // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
          var disabled = _valor !== '1'
  
          // LIMPA O VALOR DO CAMPO
          if (disabled === true) {
            this.campos[campo].value = ''
          }

          // SETA O VALOR DO CMAPO
          this.demEdiProTabItemCampoSetarValorInicial(disabled, campo)
  
          // RETORNA O VALOR CALCULADO
          return disabled
        }
      },
      proSitFisFormularioCampoStDisabled: function (campo, chaveRef) {
        // VERIFICA SE A CST PERMITE O CAMPO INFORMAOD
        var disabled = this.proSitFisFormularioCampoDisabled(campo, 'p_icms_cst', chaveRef) === true

        // VERIFICA SE EXISTE CHANCE DO CAMPO SER MOSTRADO AINDA
        if (disabled === false) {
          // PEGA O VALOR DO CAMPO
          var _valor = this.demEdiProTabItemCampoPegarValoreSelecionado('p_icms_st_bc_mod', 'ref_icms_mod_bc_st_id')

          // VERIFICA SE O CAMPO REFERENCIA TEM UM VALOR VALIDO
          disabled = [ '', null, undefined, '-1', -1 ].indexOf(_valor) !== -1

          // LIMPA O VALOR DO CAMPO
          setTimeout(() => {
            if (disabled === true && this.campos[campo].value !== '') {
              this.campos[campo].value = ''
            } else if (disabled === false && this.campos[campo].value === '') {
              this.campos[campo].value = '0.00'
            }
          }, 0)
        }

        // RETORNA O VALOR MONTADO
        return disabled
      },
      demEdiProTabItemEditarOnBuscarCFOP: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cfop: null, descricao: null } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-cfop/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCFOP(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_id_cfop.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_id_cfop.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarIcmsModBc: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsModBc(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_bc_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_bc_mod.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarIcmsRedSobre: function (callback) {
        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/referencia/pro-icms-ret-sobre/get', 'GET', null, (apiSuccess) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_bc_p_r_c.options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_bc_p_r_c.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      demEdiProTabItemEditarOnBuscarIcmsModBcSt: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc-st/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsModBcSt(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_st_bc_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {          
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_st_bc_mod.options = registros.filter(item => item.ref_icms_mod_bc_st_id !== '-1')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarIcmsOrigem: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-origem/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsOrigem(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_origem.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_origem.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstIcms: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'ref_icms_rt_id', o: '=', v: (this.$store.state.licenca.rt_id === '3' ? '3' : '1,2') }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCstIcms(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstIpi: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCstIpi(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_ipi_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // ADICIONA A OPÇÃO NÃO APLICAVEL
          registros.unshift({ ref_ipi_a: '0', ref_ipi_cst: ' ', ref_ipi_cst_desc: 'Não aplicável', ref_ipi_enq: '0', ref_ipi_ope: '0', ref_ipi_selo: '0' })

          // SETA OS VALORES RECEBIDOS
          this.campos.p_ipi_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstPisCofins: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-pis-cof-cst/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarCstPisCofins(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      demEdiProTabItemEditarOnBuscarSeloIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-selo/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)

              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarSeloIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      demEdiProTabItemEditarOnBuscarEnquadramentoIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-enquadramento/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)

              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarEnquadramentoIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      emEdiProTabItemEditarSalvar: function () {
        this.demEdiProTabItemMontarFormularioApi((formData) => {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // SETA O ID DA VENDA
          formData[chaveD] = this.cpntDemandaId

          // SETA O ID DO ITEM
          formData.id = this.cpntItemId         

          // INICIA A ROTA QUE SERÁ CHAMADA
          var router = ''

          // VERIFICA A DEMANDA QUE ESTÁ SENDO EXECUTADA
          switch (this.cpntDemanda) {
            case 'venda':
              router = '/venda/produto'
              break;
          
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/dem-produto'
              break
          
            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/dem-produto'
              break

            case 'compra':
              router = '/demanda/dem-compra/dem-produto'
              break
          }

          // CONVERTE O VALOR RECEBIDO
          if ([ '', null, undefined ].indexOf(formData.valor_uni) === -1) {
            // SETA O NOVO VALOR DO CAMPO
            formData.valor_uni_novo = this.$refs.valor_uni.value

            // CONVERTE O VALOR
            if (isNaN(formData.valor_uni_novo) === true) {
              // REMOVE O PONTO
              while (formData.valor_uni_novo.indexOf('.') !== -1) {
                formData.valor_uni_novo = formData.valor_uni_novo.replace('.', '')
              }

              // CONVERTE A VIRGULA
              formData.valor_uni_novo = formData.valor_uni_novo.replace(',', '.')
            }

            // DELETA O VALOR DO CAMPO ANTIGO
            delete formData.valor_uni
          }

          // VERIFICA SE O FORMULARIO ESTÁ PROTEGIDO OU NÃO
          if (this.campos.mascaramento.value !== this.campos.mascaramento.valueIni) {
            formData.protegido = this.campos.mascaramento.value === true ? 's' : 'n'
          }
          
          // CONVERTE O VALOR RECEBIDO
          if (formData.p_ipi_cst === ' ' || formData.p_ipi_cst === '') {
            formData.p_ipi_cst = null
          }
          if (formData.p_ipi_selo === ' ' || formData.p_ipi_selo === '') {
            formData.p_ipi_selo = null
          }
          if (formData.p_ipi_enq === ' ' || formData.p_ipi_enq === '') {
            formData.p_ipi_enq = null
          }          

          // PEGA O NOME DAS CHAVES QUE DEVE REMOVER
          var naoRemover = []

          // VERIFICA O TIPO DE DOCUMENTO SELECIONADO
          switch (this.cpntPDocTp) {
            case '':
            case 'RE':
            case 'NFe(m)':
            case 'NFAvulsa':
            case 'NFModelo02':
            case 'NFProdutor':
              naoRemover = [ chaveD, 'id', 'qtde', 'valor_uni_novo', 'p_icms_st_v', 'p_ipi_v', 'valor_des_por', 'valor_des_fixo' ]
              break
          }

          // RODA O VETOR DELETANDO AS CHAVES QUE NÃO DEVE ENVIAR
          if (naoRemover.length >= 1) {
            for (var indexF in formData) {
              if (naoRemover.indexOf(indexF) === -1) {
                delete formData[indexF]
              }
            }
          }

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
            this.demEdiProTabItemTratarRetorno(() => {
              this.$emit('DEMANDA_ATUALIZAR_DADOS', this.cpntItemId)
              // this.demEdiProTabItemAtualizarFinalidadeEmissao(() => {
              //   this.$emit('DEMANDA_ATUALIZAR_DADOS', this.cpntItemId)
              // })
              // this.demEdiProTabItemAtualizarFinalidadeEmissao(() => {
              // })
            }, retorno.lot)
          }, this.demEdiProTabItemEditarSetarStatusGeral)
        })
      },
      demEdiProTabItemTratarRetorno: function (callback, vetor, index = 0, qtdeOK = 0, qtdeErro = 0, focus = '') {
        // VERIFICA SE TEM VALOR PARA TRABALHAR
        if ([ '', null, undefined ].indexOf(vetor) !== -1 || [ '', null, undefined ].indexOf(vetor[index]) !== -1) {
          if (qtdeOK === vetor.length) {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.msgWarn('WEB [200]: Ite' +  (vetor.length === 1 ? 'm' : 'ns') + ' atualizados com sucesso.', 'success')

            // EXECUTA O CALLBACK RECEBIDO
            callback()
          }
        } else {
          // INICIA O VETOR QUE SERÁ TRATADO
          var retorno = vetor[index]

          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (retorno.code) {
            case '200':
              // MANDA FECHAR O FORMULARIO DE EDIÇÃO
              // this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(retorno.id)

              // SOMA A QUANTIDADE ENCONTRADA
              qtdeOK = (qtdeOK + 1)

              // REINICIA O PROCESSO DE VERIFICAÇÃO
              this.demEdiProTabItemTratarRetorno(callback, vetor, (index + 1), qtdeOK, qtdeErro, focus)
              break

            case '406':
            case '409':
              // VERIFICA O TIPO DE ERRO RECEBIDO
              if (typeof retorno.message === 'string' || Array.isArray(retorno.message) === true) {
                // CARREGA AM ENSAGEM RECEBIDA
                retorno.message = (typeof retorno.message === 'object' && Array.isArray(retorno.message) === true ? retorno.message.join() : retorno.message)
  
                // SETA A MENSAGEM DE ERRO RECEBIDA
                this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message, 'danger')
              }

              // SOMA A QUANTIDADE ENCONTRADA
              qtdeOK = (qtdeOK + 1)

              // REINICIA O PROCESSO DE VERIFICAÇÃO
              this.demEdiProTabItemTratarRetorno(callback, vetor, (index + 1), qtdeOK, qtdeErro, focus)
              break

            case '400':
            default:
              // SOMA A QUANTIDADE ENCONTRADA
              qtdeErro = (qtdeErro + 1)

              // VERIFICA O TIPO DE ERRO RECEBIDO
              if (typeof retorno.message === 'string' || Array.isArray(retorno.message) === true) {
                // CARREGA AM ENSAGEM RECEBIDA
                retorno.message = (typeof retorno.message === 'object' && Array.isArray(retorno.message) === true ? retorno.message.join() : retorno.message)
  
                // SETA A MENSAGEM DE ERRO RECEBIDA
                this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message, 'danger')
              } else {
                // RODA O VETOR ADICIONANDO AS MENSAGENS
                for (var indexM in retorno.message) { 
                  // TRATA A MENSAGEM RECEBIDA
                  retorno.message[indexM] = (typeof retorno.message[indexM] === 'object' && Array.isArray(retorno.message[indexM]) === true ? retorno.message[indexM].join() : retorno.message[indexM])

                  // INICIA A VARIAVEL DE CAMPO ENCONTRADO
                  var encontrado = false

                  // PROCURA O CAMPO PARA SETAR O VALOR
                  for (var indexF in this.campos) {
                    if (this.campos[indexF].apiEnv === indexM) {
                      // SETA O ERRO NO CAMPO
                      this.campos[indexF].mensagem = retorno.message[indexM]

                      // SETA QUE O CAMPO FOI ENCONTRADO
                      encontrado = true

                      // SETA O CAMPO QUE DEVE RECEBER O FOCUS
                      if (focus === '') {
                        focus = indexF
                      }
                    }
                  }
  
                  // VERIFICA SE EXISTE CAMPO PARA MENSAGEM
                  if (encontrado === false) {
                    this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message[indexM], 'danger')
                  }
                }

                // SETA O FOCUS NO CAMPO SOLICITADO
                if (focus === '') {
                  this.demEdiProTabItemSetaFocusCampo(focus)
                }
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // REINICIA O PROCESSO DE VERIFICAÇÃO
              this.demEdiProTabItemTratarRetorno(callback, vetor, (index + 1), qtdeOK, qtdeErro, focus)
              break
          }
        }
      },
      demEdiProTabItemSetaFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiProTabItemSetaFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              // MONTA O PARAMETRO QUE DEVE MANDAR NO FOCUS
              var params = elemento.select !== undefined ? false : undefined

              // REALIZA O FOCUS NO CAMPO
              elemento.cpntRealizarFocus(params)
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiProTabItemAtualizarFinalidadeEmissao: function (callback) {
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) === -1) {
          callback()
        } else {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // INICIA O FORLULARIO QUE SERÁ ENVIADO PARA API
          var formData = {}
  
          // SETA O ID DA DEMANDA QUE DEVE ATUALIZAR
          formData[chaveD] = this.cpntDemandaId
  
          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // INICIA A VARIAVEL DE ROTA
          var router = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/fin-emissao'
              break

            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/fin-emissao'
              break
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
            // PEGA O RETORNO RECEBIDO
            retorno = retorno.lot[0]
  
            // VERIFICA A AÇÃO QUE DEVE REALIZAR
            switch (retorno.code) {
              case '200':
                callback()
                break
            
              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true)
                break
            }
          }, this.demEdiProTabItemEditarSetarStatusGeral)
        }
      }
    },
    computed: {
      demEdiProTabItemEditarGerarNomeCstIcms: function () {
        return this.$store.state.licenca.rt_id === '3' ? 'CST' : 'CSOSN'
      },
      demEdiProTabItemEditarValorTipoDesconto: function () {
        return (typeof this.campos.valor_des_t.value === 'string' ? this.campos.valor_des_t.value : this.campos.valor_des_t.value.id)
      }
    }
  }
</script>
